var $ = jQuery.noConflict();


jQuery(document).ready(function(){
	var qs=window.location.search;
	var raw=getUrlParameter(qs,'raw');

	/*****************************************************************************/
	/****************** DEVICE Detection *****************************************/
	/*****************************************************************************/

	var isMobile = false; 

	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    	isMobile = true;
	}

    if (isMobile) 
		$("body").removeClass("desktop").addClass("mobile");

	/*****************************************************************************/
    /****************** Other Initialization *************************************/
    /*****************************************************************************/

	var defaultComposer = "<div class='control control-default' data-placeholder='Type your message here'></div>" + "\n";

	var hash = getUrlParameter(window.location.search,"hash");
	var start_event = getUrlParameter(window.location.search,"s");

	var theme = getUrlParameter(window.location.search,"theme");
	var sourceType = getUrlParameter(window.location.search,"raw") != '' ? 'Embedded' : 'Overlay';
	var tags = getUrlParameter(window.location.search,"t") != '' ? getUrlParameter(window.location.search,"t") : '';
	var playbook = getUrlParameter(window.location.search,"pb") != '' ? getUrlParameter(window.location.search,"pb") : '';
	var requirePhone = getUrlParameter(window.location.search,"rp") != '' ? true : false;
	var requireEmail = getUrlParameter(window.location.search,"re") != '' ? true : false;
	var validateService = getUrlParameter(window.location.search,"ev") != '' ? true : false;
	var startingLanguage = getUrlParameter(window.location.search, "l") != '' ? getUrlParameter(window.location.search, "l") : 'en-US';
	var clickToCall = getUrlParameter(window.location.search, "ctc") != '' ? true : false;
	var clickToCallPhone = getUrlParameter(window.location.search, "pn") != '' ? getUrlParameter(window.location.search, "pn") : false;
	var clickToCallTrigger = getUrlParameter(window.location.search, "ctct") != '' ? getUrlParameter(window.location.search, 'ctct') : false;
	var clickToCallUnavailableAfter = getUrlParameter(window.location.search, "ctcua") != '' ? getUrlParameter(window.location.search, "ctcua") : '';
	var clickToCallTimezone = getUrlParameter(window.location.search, "ctctz") != '' ? getUrlParameter(window.location.search, 'ctctz') : false;
	var slimbotIntroTitle = getUrlParameter(window.location.search, "sbt") != '' ? getUrlParameter(window.location.search, 'sbt') : 'Thank you for contacting us, which of the below best describes your situation?';
	var slimbotBtn1Text = getUrlParameter(window.location.search, "sbb1") != '' ? getUrlParameter(window.location.search, 'sbb1') : '';
	var slimbotBtn2Text = getUrlParameter(window.location.search, "sbb2") != '' ? getUrlParameter(window.location.search, 'sbb2') : '';
	var slimbotCTCtext = getUrlParameter(window.location.search, "sbctct") != '' ? getUrlParameter(window.location.search, 'sbctct') : '';
	var customId = getUrlParameter(window.location.search, "cb") != '' ? getUrlParameter(window.location.search, 'cb') : '';
	var noSave = getUrlParameter(window.location.search, "ns") != '' ? getUrlParameter(window.location.search, "ns") : '';
	var previewBot = getUrlParameter(window.location.search, "prvbot") != '' ? getUrlParameter(window.location.search, "prvbot") : '';
	var playback_id = getUrlParameter(window.location.search, "pvi") != '' ? getUrlParameter(window.location.search, "pvi") : '';
	var inner_chat_button_color = getUrlParameter(window.location.search, "icbc") != '' ? ("#" + getUrlParameter(window.location.search, "icbc")) : '#3776f6';
	var chat_progress_bar_color = getUrlParameter(window.location.search, "cpbc") != '' ? ("#" + getUrlParameter(window.location.search, "cpbc")) : '#3776f6';
	var chat_firmname_color = getUrlParameter(window.location.search, "cfnc") != '' ? ("#" + getUrlParameter(window.location.search, "cfnc")) : '#9a9a9a';
	var chat_header_icon_color = getUrlParameter(window.location.search, "chic") != '' ? ("#" + getUrlParameter(window.location.search, "chic")) : '#9c9c9c';
	var chat_response_color = getUrlParameter(window.location.search, "crc") != '' ? ("#" + getUrlParameter(window.location.search, "crc")) : '#f3f4f7';
	var chat_header_bg_color = getUrlParameter(window.location.search, "chbc") != '' ? ("#" + getUrlParameter(window.location.search, "chbc")) : '#ffffff';
	var chat_body_bg_color = getUrlParameter(window.location.search, "cbbc") != '' ? ("#" + getUrlParameter(window.location.search, "cbbc")) : '#ffffff';
	var chat_ctc_icon_color = getUrlParameter(window.location.search, "ccic") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#3776f6';
	var chat_button_style = getUrlParameter(window.location.search, "cbs") != '' ? getUrlParameter(window.location.search, "cbs") : 'default';
	var chat_button_wrapping = getUrlParameter(window.location.search, "cbw") != '' ? getUrlParameter(window.location.search, "cbw") : 'no';
	var chat_button_border_radius = getUrlParameter(window.location.search, "cbbr") != '' ? getUrlParameter(window.location.search, "cbbr") : '5';
	//var fullyCustomChatbot = getUrlParameter(window.location.search, "fccb") != '' ? getUrlParameter(window.location.search, 'fccb') : false;
	var fullyCustomChatbot = '';
	// var case_card_success_header_color = getUrlParameter(window.location.search, "ccshc") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#2cab38';
	// var case_card_success_body_color = getUrlParameter(window.location.search, "ccsbc") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#FFF';
	// var case_card_nocase_header_color = getUrlParameter(window.location.search, "ccnhc") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#d75452';
	// var case_card_nocase_body_color = getUrlParameter(window.location.search, "ccnbc") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#FFF';
	// var case_card_default_header_color = getUrlParameter(window.location.search, "ccdhc") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#FDC02F';
	// var case_card_default_body_color = getUrlParameter(window.location.search, "ccdbc") != '' ? ("#" + getUrlParameter(window.location.search, "ccic")) : '#FFF';

	var widgetUrl = window.location.href;

	/***** DEBUGGING **************/
	//validateService = true;
	//get text color for the few we need to
	function getTextColorBasedOnBackground(backgroundColor) {
        // Extract the RGB values from the hex color
        var r = parseInt(backgroundColor.substring(1, 3), 16);
        var g = parseInt(backgroundColor.substring(3, 5), 16);
        var b = parseInt(backgroundColor.substring(5, 7), 16);
      
        // Calculate luminance
        var luminance = 0.299 * r + 0.587 * g + 0.114 * b;
      
        // Return white text for dark backgrounds and black text for light backgrounds
        return luminance > 128 ? '#000000' : '#FFFFFF';
    }

	function getLighterColorAndText(curColor,botBackground) {
        // Extract the RGB values from the hex color
        var r = parseInt(curColor.substring(1, 3), 16);
        var g = parseInt(curColor.substring(3, 5), 16);
        var b = parseInt(curColor.substring(5, 7), 16);
		var background_r = parseInt(botBackground.substring(1, 3), 16);
        var background_g = parseInt(botBackground.substring(3, 5), 16);
        var background_b = parseInt(botBackground.substring(5, 7), 16);
        // Calculate luminance
        var luminance = 0.299 * r + 0.587 * g + 0.114 * b;
		var luminanceText = 0.299 * background_r + 0.587 * background_g + 0.114 * background_b;
		var selectedTextColor = luminance > 128 ? '#000000' : '#FFFFFF';
		//becasuse we are using opacity we need to make sure that selected text color is visible on what is underneath
        var textColor = luminanceText > (128) ? '#000000' : '#FFFFFF';
		var lighterColor = "rgba(" + r + "," + g + "," + b + ",0.3)";
		var selectedColor = "rgba(" + r + "," + g + "," + b + ",1)";
		return {textColor: textColor, lighterColor: lighterColor, selectedColor: selectedColor, selectedTextColor: selectedTextColor}
    }
	
	
	function getFilterForColor(hexColor) {
		
		if(hexColor == "#FFFFFF"){
			//return white filter
			return 'invert(100%) brightness(100%)'
		}
		else{
			//return black filter
			return 'brightness(0%)'
		} 
	}

	function convertToFilter(color){
		var r = parseInt(color.substring(1, 3), 16);
		var g = parseInt(color.substring(3, 5), 16);
		var b = parseInt(color.substring(5, 7), 16);
		var rgb = {r: r, g: g, b: b};
		var result = findFilter(rgb);
		return result.filter;
	}
	
	//set up color classes
	var applyAllChanges = true;
	if((theme == 'modern' || theme == '') || (theme == 'classic' && sourceType == 'Embedded')){
		applyAllChanges = false;
		$('.chat-powered-by').hide();
		$('.powered_by').show();
	}
	else{
		$('.powered_by').html('<span></span>');
		$('.chat-powered-by').show();
	}
	var chatButtonTextColor = getTextColorBasedOnBackground(inner_chat_button_color);
	var chatButtonFilterColor = getFilterForColor(chatButtonTextColor); //used for images
	var progressBarTextColor = getTextColorBasedOnBackground(chat_progress_bar_color);
	var chatResponseTextColor = getTextColorBasedOnBackground(chat_response_color);
	var chat_header_icon_color_filter = convertToFilter(chat_header_icon_color);
	var chat_ctc_icon_color_filter = convertToFilter(chat_ctc_icon_color);
	var chat_option_select_color = getLighterColorAndText(chat_response_color,applyAllChanges ? chat_body_bg_color : '#ffffff');
	var chat_inner_color_button_lighter_options = getLighterColorAndText(inner_chat_button_color, applyAllChanges ? chat_body_bg_color : '#ffffff');
	var cssHTML = '';
	if(chat_button_style == 'default'){
		cssHTML += '.chat-button-color-sender-icon img{ filter: ' + convertToFilter(inner_chat_button_color) + '!important }';
		if(inner_chat_button_color !== "#3776f6"){
			cssHTML += '.chat-button-request-color { background-color: ' + inner_chat_button_color + '!important; color: ' + chatButtonTextColor + '!important; border-color: ' + inner_chat_button_color +'!important; }';
			cssHTML += '.chat-button-color { background-color: ' + inner_chat_button_color + '!important; color: ' + chatButtonTextColor + '!important; border-color: ' + inner_chat_button_color +'!important; border-radius: ' + chat_button_border_radius + 'px!important; }';
			cssHTML += '.chat-button-color img { filter: ' + chatButtonFilterColor + '!important }';
			cssHTML += '.chat-custom-color-border.focused { border-color: ' + inner_chat_button_color + '!important }';
			cssHTML += '.chat-custom-color-border { border-color: ' + chat_inner_color_button_lighter_options.lighterColor + '!important }';
			cssHTML += '.option-list li:hover { background-color: ' + inner_chat_button_color + '!important; color: ' + chatButtonTextColor + '!important;}';
		}
	}
	else{
		cssHTML += '.chat-button-color-sender-icon img{ filter: ' + convertToFilter(inner_chat_button_color) + '!important }';
		if(chat_button_style == 'outline_white'){
			cssHTML += '.chat-button-color { background-color:#FFFFFF!important; color: ' + inner_chat_button_color + '!important; border-color: ' + inner_chat_button_color +'!important; border-radius: ' + chat_button_border_radius + 'px!important; }';
		}
		else{
			cssHTML += '.chat-button-color { background-color:' + chat_body_bg_color + '!important; color: ' + inner_chat_button_color + '!important; border-color: ' + inner_chat_button_color +'!important; border-radius: ' + chat_button_border_radius + 'px!important; }';

		}
		cssHTML += '.chat-button-request-color { background-color: ' + inner_chat_button_color + '!important; color: ' + chatButtonTextColor + '!important; border-color: ' + inner_chat_button_color +'!important; }';
		cssHTML += '.chat-button-color img { filter: ' + chatButtonFilterColor + '!important }';
		cssHTML += '.chat-custom-color-border.focused { border-color: ' + inner_chat_button_color + '!important }';
		cssHTML += '.chat-custom-color-border { border-color: ' + chat_inner_color_button_lighter_options.lighterColor + '!important }';
		cssHTML += '.option-list li:hover { background-color: ' + inner_chat_button_color + '!important; color: ' + chatButtonTextColor + '!important;}';
	}
	if(chat_button_wrapping == 'yes'){
		cssHTML += '.custom-button-wrapping {display:flex; flex-wrap:wrap; gap:5px; column-gap:5px; align-items:end}';
		cssHTML += '.custom-button-wrapping-dos {justify-content:space-evenly;}';
		cssHTML += '.custom-button-wrapping-multiple {justify-content:end;}';
		cssHTML += '.custom-button-wrapping button{margin-top:0px!important;height:min-content;}';
		cssHTML += '.custom-button-wrapping-dos button{width:45%}';
		cssHTML += '.custom-button-wrapping-multiple button{max-width:45%; width: auto;}';
		cssHTML += '.custom-checkbox-wrapping-multiple {display:flex; flex-wrap:wrap; gap:2px;align-items:stretch;justify-content: end;}';
		cssHTML += '.custom-checkbox-wrapping-multiple .button-check{max-width:49%;width:auto;}';
		cssHTML += '.custom-checkbox-wrapping-multiple .button-check button{width: 100%;height:100% }';
	}
	if(chat_progress_bar_color !== "#3776f6"){
		cssHTML += '.chat-progress-bar-color { background-color: ' + chat_progress_bar_color + '!important; color: ' + progressBarTextColor + '!important }';
	}
	if(chat_firmname_color !== "#9a9a9a"){
		cssHTML += '.chat-firm-name-color { color: ' + chat_firmname_color + '!important }';
	}
	if(chat_header_icon_color !== "#9c9c9c"){
		cssHTML += '.chat-header-icon-color { filter: ' + chat_header_icon_color_filter + '!important }';
	}
	else{
		chat_header_icon_color_filter = convertToFilter("#9c9c9c");
		cssHTML += '.chat-header-icon-color { filter: ' + chat_header_icon_color_filter + ' }';
		cssHTML += '#video-control-icon { filter: brightness(0%) saturate(100%)  }';
	}
	if(chat_ctc_icon_color !== "#3776f6"){
		cssHTML += '.chat_ctc_icon_color { filter: ' + chat_ctc_icon_color_filter + '!important }';
		cssHTML += '.click-call-trigger {color: ' + chat_ctc_icon_color + ' !important }';
	}
	else{
		chat_ctc_icon_color_filter = convertToFilter("#3776f6");
		cssHTML += '.chat_ctc_icon_color { filter: ' + chat_ctc_icon_color_filter + ' }';
	}
	if(chat_response_color !== "#f3f4f7"){
		if(applyAllChanges){
			cssHTML += '.chat-response-color { background-color: ' + chat_response_color + '!important; color: ' + chatResponseTextColor + '!important }';
		}
		cssHTML += '.chat-button-option-color { background-color: ' + chat_option_select_color.lighterColor + '!important; color: ' + chat_option_select_color.textColor + '!important; border-color: ' + chat_option_select_color.lighterColor + '!important;  border-radius: ' + chat_button_border_radius + 'px!important; }';
		cssHTML += '.chat-button-option-color.checked { background-color: ' + chat_option_select_color.selectedColor + '!important; color: ' + chat_option_select_color.selectedTextColor + '!important; border-color: ' + chat_option_select_color.selectedColor +'!important }';
		cssHTML += '.chat-button-option-color img { filter: ' + convertToFilter(chat_option_select_color.textColor) +'!important }';
		cssHTML += '.chat-button-option-color.checked img { filter: ' + convertToFilter(chat_option_select_color.selectedTextColor) +'!important }';
	}
	if(chat_header_bg_color !== "#ffffff" && applyAllChanges){
		cssHTML += '.chat-header-bg-color { background-color: ' + chat_header_bg_color + '!important } ';
	}
	if(chat_body_bg_color !== "#ffffff" && applyAllChanges){
		//need to adjust the text counter colors if adjustments are made
		cssHTML += '.chat-body-bg-color { background-color: ' + chat_body_bg_color + '!important; color: ' + getTextColorBasedOnBackground(chat_body_bg_color) + '!important }';
		cssHTML += '.chat-body-bg-color textarea::placeholder { color: ' + getTextColorBasedOnBackground(chat_body_bg_color) + '!important; opacity:0.8; }';
		cssHTML += '.char-counter { color: ' + getTextColorBasedOnBackground(chat_body_bg_color) + '!important }';
		cssHTML += '.character-warning { color: ' + getTextColorBasedOnBackground(chat_body_bg_color) + '!important; font-weight:600!important; }';
		cssHTML += '.custom-case-card-border { border-color: ' + chat_body_bg_color + '!important }';
		cssHTML += '.deceased-wrapper label { color: ' + getTextColorBasedOnBackground(chat_body_bg_color) + '!important }';

	}
	//add in customization based on if the case card colors are changed
	// if(case_card_default_body_color !== "#FFF"){
	// 	cssHTML += '.case-card .default { background-color: ' + case_card_default_body_color + '!important; color: ' + getTextColorBasedOnBackground(case_card_default_body_color) + '!important }';
	// }
	// if(case_card_success_body_color !== "#FFF"){
	// 	cssHTML += '.case-card .case { background-color: ' + case_card_success_body_color + '!important; color: ' + getTextColorBasedOnBackground(case_card_success_body_color) + '!important }';
	// }
	// if(case_card_nocase_body_color !== "#FFF"){
	// 	cssHTML += '.case-card .nocase { background-color: ' + case_card_nocase_body_color + '!important; color: ' + getTextColorBasedOnBackground(case_card_nocase_body_color) + '!important }';
	// }
	// if(case_card_success_header_color !== "#2cab38"){
	// 	cssHTML += '.case-card-title .case { background-color: ' + case_card_success_header_color + '!important; color: ' + getTextColorBasedOnBackground(case_card_success_header_color) + '!important }';
	// }
	// if(case_card_default_header_color !== "#FDC02F"){
	// 	cssHTML += '.case-card-title .default { background-color: ' + case_card_default_header_color + '!important; color: ' + getTextColorBasedOnBackground(case_card_default_header_color) + '!important }';
	// }
	// if(case_card_nocase_header_color !== "#d75452"){
	// 	cssHTML += '.case-card-title .nocase { background-color: ' + case_card_nocase_header_color + '!important; color: ' + getTextColorBasedOnBackground(case_card_nocase_header_color) + '!important }';
	// }
	if(cssHTML !== '') $('<style>').prop('type','text/css').html(cssHTML).appendTo('head');

	var caseIdGlobal = null;

	if(playback_id !== ''){
		//<mux-player playback-id="bFHX9a00wMmgyVvPnD4HmzFXvloBHuLA5ftYqWiwB74s" loop style="border-radius:5px;aspect-ratio: 9/16; height:100%;width:100%;--media-object-fit: cover;--media-object-position: center;  --fullscreen-button: none;--cast-button: none;--playback-rate-button: none;--rendition-selectmenu: none; --volume-range: none; "></mux-player> 
		var muxPlayerHtml = "<mux-player playback-id='" + playback_id +"' loop style='border-radius:5px;aspect-ratio: 9/16; height:100%;width:100%;--media-object-fit: cover;--media-object-position: center;  --fullscreen-button: none;--cast-button: none;--playback-rate-button: none;--rendition-selectmenu: none; --volume-range: none; '></mux-player> ";
		$("#videoIconWrapper").show();
		$("#videoCollapse").html(muxPlayerHtml);
	}
	else{
		$("#videoIconWrapper").hide();
		$("#videoCollapse").hide();
	}
	if (theme == "modern") {
		var widgetType = 'Instant Case Evaluator';
		 $('body').removeClass("classic").addClass("modern");
		$('.language-modern').attr('style','display: inline');
    	 //var language = $('.language-modern').find(':selected').val();
		 $('.language-modern .select-language').val(startingLanguage);
    	 var language = $('.language-modern .select-language option:selected').val();
		 console.log("Language: " + language);

		// Small amount of clients are not setting language.  This sets language if it is undefined from the selection above.
		if (language === undefined) {
			language = startingLanguage;
			console.log("Language is undefined, setting to: " + language);
		}

		// Load menu from files if there is no starting point and using Overlay form.  This is being done so advertisments can't see keywords in the menu.
		if ((start_event == '' && sourceType == 'Embedded') || start_event == 'slimbot' || sourceType == 'Overlay') {
			$("#main-menu").load("main_menu.html");
			$(".faq-content-drug").load("drug_menu.html");
			$(".faq-content-bloodpressure").load("bloodpressure_menu.html");
			$(".faq-content-device").load("device_menu.html");
			$(".faq-content-toxic").load("toxic_menu.html");
			$(".faq-content-liability").load("liability_menu.html");
			$(".faq-content-work").load("work_menu.html");
			$(".faq-content-toxic-sub").load("work_toxic_submenu.html");

			//Loads the custom bot menu
			getCustomBotMenu(hash,language);
		}
	}
	else {

		var widgetType = 'Conversational';
		$('.language-classic').attr('style','display: inline');
		//var language = $('.language-classic').find(':selected').val();
		$('.language-classic .select-language').val(startingLanguage);
		var language = $('.language-classic .select-language option:selected').val();
		console.log("Language: " + language);

		// Small amount of clients are not setting language.  This sets language if it is undefined from the selection above.
		if (language === undefined) {
			language = startingLanguage;
			console.log("Language is undefined, setting to: " + language);
		}

		// Load menu for Conversational bot. 
		$("#main-menu").load("main_menu.html");
		$(".faq-content-drug").load("drug_menu.html");
		$(".faq-content-bloodpressure").load("bloodpressure_menu.html");
		$(".faq-content-device").load("device_menu.html");
		$(".faq-content-toxic").load("toxic_menu.html");
		$(".faq-content-liability").load("liability_menu.html");
		$(".faq-content-work").load("work_menu.html");
		$(".faq-content-toxic-sub").load("work_toxic_submenu.html");

		//Loads the custom bot menu
		getCustomBotMenu(hash,language);
	}

	//console.log("widgetType: " + widgetType + " sourceType: " + sourceType);
	//console.log("Tags: " + tags);


	var messenger = {
		socket: null,
		reconnect: true,
		connected: false,
		synced: false,
		lastMsg: '',

		connect: function() {
			var self = this;
			this.synced = true;

			this.socket = io({reconnection: self.reconnect, query: {hash: hash, startEvent: start_event, language: language, widgetType: widgetType, sourceType: sourceType, tags: tags, widgetUrl: widgetUrl, playbook: playbook, slimbotSettingsTitle: slimbotIntroTitle, slimbotSettingsBtn1: slimbotBtn1Text, slimbotSettingsBtn2: slimbotBtn2Text, slimbotSettingsCTCtext: slimbotCTCtext, clickToCall: clickToCall, customId: customId, noSave: noSave, previewBot: previewBot,fullyCustomChatbot: fullyCustomChatbot}});
	
			this.socket.on('connect', function(){
				self.connected = true;
        		console.log("connect");

    		});

			this.socket.on('disconnect', function(reason){
				self.connected = false;
        		self.synced = false;

				if (!self.reconnect) {
        			setTimeout(function() {
            			this.open();    
        			}, 1000);
				}
        		console.log("disconect: " + reason);
        		logger("disconnection detected",_state[_state.length-1]);
    		});

			this.socket.on("rebuild",function(data) {
				console.log("rebuild");
        		if (data.code == "success") {
            		self.synced = true;
            		if (self.lastMsg) {
                		sendMessage(self.lastMsg);
            		}
        		}
    		});

			this.socket.on('chat message', function(jsonResponse){

        		if (!self.synced)
            		return;
				handleResponse(jsonResponse);
				//if (raw === 'yes')
					//setTimeout(updateHeight, 100);
			});

			this.socket.on("messageComplete", function(jsonResponse) {

        		if (!self.synced) {
            		self.rebuild();
            		return;
        		}
				messageComplete(jsonResponse);
			});

			this.socket.on("backPressed", function(jsonResponse) {
				handleBackPress(jsonResponse);
				//if (raw === 'yes')
					//setTimeout(updateHeight, 100);
			});

			this.socket.on('connect_error', function(error) {
        		console.log("connect_error: " + error);
    		});

    		this.socket.on('connect_timeout', function(error) {
        		console.log("connect_timeout: " + error );
    		});

    		this.socket.on('error', function(error) {
        		console.log("error: " + error);
    		});
		
    		this.socket.on('reconnect', function(attemptNumber) {
        		console.log("reconnect: " + attemptNumber);
    		});
		
    		this.socket.on('reconnect_attempt', function(attemptNumber) {
        		console.log("reconnect_attempt: " + attemptNumber);
    		});
		
    		this.socket.on('reconnecting', function(attemptNumber) {
        		console.log("reconnecting: " + attemptNumber);
    		});
		
    		this.socket.on('reconnect_error', function(error) {
        		console.log("reconnect_error: " + error);
    		});
		
    		this.socket.on('reconnect_failed', function() {
        		console.log("reconnect_failed");
    		});

		},
		rebuild: function() {
			console.log("rebuildConnection()");
        	this.socket.emit("rebuild",_state[_state.length-1]);
        },
		send: function (msg) {
        
        	this.lastMsg = msg;
        
        	if (!this.synced) {
            	this.rebuild();
            	return;
        	}   

        	prepareNextMessage(msg);

        	this.socket.emit('chat message',msg);

        	this.lastMsg = '';
    	}
    }

	messenger.connect();

	$('.controls').on('click', function(e) {
		if (raw === 'yes')
			updateHeight();
            		//setTimeout(updateHeight, 500);
			
	});

	/*****************************************************************************/
    /*************************** Language Selection ******************************/
    /*****************************************************************************/

	//$('select.language').on('change', function(e) {
	$('.language-classic, .language-modern').on('change', function(e) {
        language = $(this).find(':selected').val();
        //language = $(this).children('option:selected').val();
		console.log("Language: " + language);
		translateMenu(language);
		restart_bot();
	});

	/*****************************************************************************/
	/****************** Relationship / Radio Control *****************************/
	/*****************************************************************************/

	//checkbox clicked
	$('.controls').on('click','.radio-select .button-radio .btn',function(e) {
        e.preventDefault();

		var thisControl = $(this).closest('.control');

		radioButtonSelected($(this));

		var checkedRelationElem = $('.radio-relation .button-radio .btn.checked',thisControl);

        if (checkedRelationElem.data('trigger') == "deceased-wrapper" && $(".deceased-wrapper").length) {
			$('.select-btnWrapper .btn',thisControl).attr('disabled',true);
            $(".deceased-wrapper").slideDown(
					{complete: function() {
							
							var checkedDodElem = $('.radio-deceased .button-radio .btn.checked',thisControl);
        					
							updateHeight();
						
        					if (checkedDodElem.data('trigger') == "dod-wrapper" ) {
								$('.select-btnWrapper .btn',thisControl).attr('disabled',true);
            					$(".dod-wrapper").slideDown({complete: function() { 
									toggleRelationSubmitButton(thisControl) 
									updateHeight();
								} });
							}
        					else	
            					$(".dod-wrapper").slideUp({complete: function() { 
									toggleRelationSubmitButton(thisControl)
									updateHeight();
								} });
						}
					}
			);
		}
		else if ($(".deceased-wrapper").length) {
            $(".deceased-wrapper").slideUp({complete: function() { toggleRelationSubmitButton(thisControl) } });
		}
		else {
			toggleRelationSubmitButton(thisControl);
		}

	});

	//Selection changes
	$('.controls').on('change','.dod-wrapper select',function(e) {

		var thisControl = $(this).closest('.control');

		toggleRelationSubmitButton(thisControl);

	});

	//Enable / disable submit button
	function toggleRelationSubmitButton(thisControl) {
		var showSubmit = false;
		if ($('.dod-wrapper:visible',thisControl).length) {
			if (validateDate(thisControl))
				showSubmit = true;
		}
		else {
			$(".radio-select:visible",thisControl).each(function() {
            	if ($('.button-radio .btn',$(this)).hasClass("checked")) {
                    showSubmit = true;
				}
				else {
                    showSubmit = false;
					return;
				}
            });
		}

		if (showSubmit)
			$('.select-btnWrapper .btn',thisControl).removeAttr('disabled');
		else
			$('.select-btnWrapper .btn',thisControl).attr('disabled',true);
	}

	function radioButtonSelected(thisRadio) {

        var thisGroup = thisRadio.closest('.radio-select');
        var thisControl = thisRadio.closest('.control');
        var otherButtons = $('.button-radio .btn',thisGroup).not(thisRadio);
        var thisIcon = $('img',thisRadio);

		$(".button-radio .btn",thisGroup).not(thisRadio).removeClass("checked");
		thisRadio.addClass("checked");
		//so we need to add an image/remove image 
        $('img',otherButtons).attr("src", "./lib/fontawesome/svgs/regular/circle.svg");
		$('img',otherButtons).css("filter", "invert(0%) sepia(92%) saturate(0%) hue-rotate(337deg) brightness(92%) contrast(107%)");
        thisIcon.attr("src", "./lib/fontawesome/svgs/solid/check-circle.svg");
		thisIcon.css("filter", "invert(35%) sepia(40%) saturate(2574%) hue-rotate(203deg) brightness(104%) contrast(93%)");
	}


	/*****************************************************************************/
	/****************** Multiple Select Control **********************************/
	/*****************************************************************************/

	$('.controls').on('click','.button-check .btn',function(e) {
		e.preventDefault();
		//need to change the filter for the colors on the images as we switch them over
		$(this).toggleClass('checked');

		var thisControl = $(this).closest('.control');
		var thisIcon = $('img',this);
		var otherButtons = $('.button-check .btn',thisControl).not($(this));

		if ($(this).hasClass('single') && $(this).hasClass('checked')) {
			$('.button-check .btn',thisControl).not($(this)).removeClass('checked');
			$('img',otherButtons).attr("src", "./lib/fontawesome/svgs/regular/square.svg");
			$('img',otherButtons).css("filter", "invert(0%) sepia(92%) saturate(0%) hue-rotate(337deg) brightness(92%) contrast(107%)");
			thisIcon.attr("src", "./lib/fontawesome/svgs/solid/check-square.svg");
			thisIcon.css("filter", "invert(35%) sepia(40%) saturate(2574%) hue-rotate(203deg) brightness(104%) contrast(93%)");
		}
		else if ($(this).is('.checked')) {
			thisIcon.attr("src", "./lib/fontawesome/svgs/solid/check-square.svg");
			thisIcon.css("filter", "invert(35%) sepia(40%) saturate(2574%) hue-rotate(203deg) brightness(104%) contrast(93%)");
			$('.button-check .btn.single',thisControl).removeClass('checked');
			$('.button-check .btn.single img',thisControl).attr("src", "./lib/fontawesome/svgs/regular/square.svg");
			$('.button-check .btn.single img',thisControl).css("filter", "invert(0%) sepia(92%) saturate(0%) hue-rotate(337deg) brightness(92%) contrast(107%)");
		}
		else {
			$('img',this).attr("src", "./lib/fontawesome/svgs/regular/square.svg");
			$('img',this).css("filter", "invert(0%) sepia(92%) saturate(0%) hue-rotate(337deg) brightness(92%) contrast(107%)");
		}

		if ($('.button-check .btn',thisControl).hasClass('checked')) {
			$('.select-btnWrapper .btn',thisControl).removeAttr('disabled');
			//$('.select-btnWrapper',thisControl).show("slide", { direction: "down" }, 200);
		}
		else {
			//$('.select-btnWrapper',thisControl).hide("slide", { direction: "down" }, 200);
			$('.select-btnWrapper .btn',thisControl).attr('disabled',true);
		}

	});

	/*****************************************************************************/
	/****************** Multiple Radio Control **********************************/
	/*****************************************************************************/

	$(document).on('click', '.radioInput, .radioDateOption', function(e) {
		var thisControl = $(this).closest('.control');
		var allChecked = true;
		var trigger = $(this).data('trigger');
		var untrigger = $(this).data('untrigger');
		//check if something should show
		$('.' + trigger).removeClass('d-none');
		$('.' + untrigger).addClass('d-none');
		$("input:radio").each(function(){
			var name = $(this).attr('name');
			var radioGroup = $(this).closest('.radioGroup');
			if($("input:radio[name="+name+"]:checked").length == 0 && !radioGroup.hasClass('d-none')){
				allChecked = false;
			}
		});
		//validateDate
		$(".radioDateOption").each(function(){
			var radioGroup = $(this).closest('.radioGroup');
			var isDateGood = validateDate($(".radioDateOption"));
			if(!isDateGood && !radioGroup.hasClass('d-none')) allChecked = false;
		});
		if (allChecked) {
			$('.select-btnWrapper .btn',thisControl).removeAttr('disabled');
		}
		else {
			//$('.select-btnWrapper',thisControl).hide("slide", { direction: "down" }, 200);
			$('.select-btnWrapper .btn',thisControl).attr('disabled',true);
		}

	});
	/*****************************************************************************/
	/****************** Single Select Control **********************************/
	/*****************************************************************************/

	 $(document).on('change','.control.select select',function() {

		if ($(this).val() !== '' && $(this).val() !== undefined) {

			$('button',$(this).closest('.control.select')).removeAttr('disabled');
			//$('.modern .select .select-btnWrapper').show("slide", { direction: "down" }, 200);
		}
		else {
			$('button',$(this).closest('.control.select')).attr('disabled',true);
			//$('.modern .select .select-btnWrapper').hide("slide", { direction: "down" }, 200);
		}
    });
	$(document).on('change','.control.select #selectControlID',function() {
		if ($(this).val() !== '' && $(this).val() !== undefined) {
			//now need to check to make sure that a value is selected
			var ulList = $(this).prev('ul');
			var liItems = $(ulList).children('li');
			var selectedOption = false;
			var selectedData = $(this).val();
			$.each(liItems, function(option, value){
				if($(value).data('display') == selectedData && $(value).hasClass('selected-option')){
					selectedOption = true;
				}
			});
			if(selectedOption){
				$('button',$(this).closest('.control.select')).removeAttr('disabled');
			}
			else{
				$('button',$(this).closest('.control.select')).attr('disabled',true);
			}
		}
		else {
			$('button',$(this).closest('.control.select')).attr('disabled',true);
		}
    });

	 $(document).on('change','.control.countySelect select',function() {
		//we need to make sure that county and state are both full
		if ( ($(".county").val() !== '' && $(".county").val() !== undefined) && ($(".stateCounty").val() !== '' && $(".stateCounty").val() !== undefined)){

			$('button',$(this).closest('.control.countySelect')).removeAttr('disabled');
			//$('.modern .select .select-btnWrapper').show("slide", { direction: "down" }, 200);
		}
		else {
			$('button',$(this).closest('.control.countySelect')).attr('disabled',true);
			//$('.modern .select .select-btnWrapper').hide("slide", { direction: "down" }, 200);
		}
		
    });
	/*****************************************************************************/
	/****************** Date Select Control **************************************/
	/*****************************************************************************/

	 $(document).on('change','.control.dateSelect select',function() {

		var theseControls = $(this).closest('.control.dateSelect');

        if (validateDate(theseControls)) {
            $('button',theseControls).removeAttr('disabled');
            //$('.modern .dateSelect .select-btnWrapper').show("slide", { direction: "down" }, 200);
        }
        else {
            $('button',theseControls).attr('disabled',true);
            //$('.modern .dateSelect .select-btnWrapper').hide("slide", { direction: "down" }, 200);
        }
    });

    function validateDate(thisControl) {

        var result = true;
        var warningIcon = "<span><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:18px;height:16px'></span></i>";
        var errorMsg=warningIcon + " Date cannot be in the future";

        var month = $('select[name=_month] option:selected',thisControl).val();
        var day = $('select[name=_day] option:selected',thisControl).val();
        var year = $('select[name=_year] option:selected',thisControl).val();

		$('select',thisControl).each(function() {
			if (!$(this).val()) {
				result=false;
				return;
			}
		});

		if (result) {
			if(!(thisControl.hasClass("no-validate"))){
				day = (day === undefined) ? 1 : day;
				var currentDate = new Date();
				var inputDate = new Date(month + " " + day + " " + year);

				if (inputDate > currentDate) {
					thisControl.addClass("error");
					$('.dateErrorLabel').html(errorMsg).show();
					result = false;
				}
				else {
					thisControl.removeClass("error");
					$('.dateErrorLabel').hide();
				}
			}
		}

        return result;
    }
	/*****************************************************************************/
	/****************** Social Security Control **********************************/
	/*****************************************************************************/
	$(document).on('input','.control.socialSecurity input', function() {
		var ssInputs = document.getElementsByClassName("ssInput");
		var isNum = true;
		var filled =  true;
		for(var i = 0; i < ssInputs.length; i++){
			var num = ssInputs[i].value;
			var regex = /^[0-999]+$/;
			if(!num.match(regex) && num !== ''){
				isNum = false;
			}
			if( num.length != ssInputs[i].maxLength ){
				filled = false;
				ssInputs[i].style.borderColor='red';
			}
			else{
				ssInputs[i].style.borderColor='#ced4da';
				if(i+1 < ssInputs.length){
					ssInputs[i+1].focus();
				}
			}
			
		}
		var thisControl = $(this).closest('.control.socialSecurity');
		
		if (isNum && filled) {
			$('button',$(this).closest('.control.socialSecurity')).removeAttr('disabled');
			thisControl.removeClass("error");
			$('.socialErrorLabel').hide();
		}
		else if(!isNum){
			//only show message if at max length
			$('button',$(this).closest('.control.socialSecurity')).attr('disabled',true);
			
			thisControl.addClass("error");
			var warningIcon = "<span class='endCheckBox'><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:15px;height:14px'></span></i>";
			var errorMsg=warningIcon + " Please enter only numbers in the valid 3-2-4 format for SSN numbers";
			$('.socialErrorLabel').html(errorMsg).show();
		}
		else{
			$('button',$(this).closest('.control.socialSecurity')).attr('disabled',true);
			thisControl.removeClass("error");
			$('.socialErrorLabel').hide();
		}
    });

	/*****************************************************************************/
	/****************** Input Box Control **********************************/
	/*****************************************************************************/
	 $(document).on('keyup change','.control.inputBox',function() {

		var thisControl = $(this).closest('form');
		var maxlength = ($(".control input",thisControl).attr('data-maxlength')) ? $(".control input",thisControl).attr('data-maxlength') : '999';
		var minlength = ($(".control input",thisControl).attr('data-minlength')) ? $(".control input",thisControl).attr('data-minlength') : '0';
		var inputType = ($(".control input",thisControl).attr('type'));

		var warningIcon = "<span class='endCheckBox'><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:15px;height:14px'></span></i>";

		// Set errorMsgMaxlength based on inputType and the values of minlength and maxlength
		if (inputType == 'number') {
			var errorMsgMaxlength = (minlength == maxlength) ? warningIcon + " Number has to be " + maxlength + " digits" : warningIcon + " Number has to be " + maxlength + " digits or less";
		}
		else {
			var errorMsgMaxlength = (minlength == maxlength) ? warningIcon + " Text has to be " + maxlength + " characters" : warningIcon + " Text has to be " + maxlength + " characters or less";
		}

		if (!$(".control input",thisControl).val()) {
			$('button',$(this).closest('.control.inputBox')).attr('disabled',true);
		}
		else if ($(".control input",thisControl).val().length > maxlength) {
			// Checks to see if val is over maxlegth, and then shows error message and disable button
			$('button',$(this).closest('.control.inputBox')).attr('disabled',true);
			$(".control input",thisControl).addClass("validate error").next('.errorLabel').html(errorMsgMaxlength).show();
		}
		else if ($(".control input",thisControl).val().length >= minlength) {
			// Checks to see if val is over minlegth, and then removes error message and enable button. Error message for minlength is applied during submit
        	$('button',$(this).closest('.control.inputBox')).removeAttr('disabled');
			$(".control input",thisControl).removeClass("error").next('.errorLabel').hide();
		}
    });

	$('.controls').on("keydown",".control.inputBox",function(e) {
		//Prevents Enter key from submitting on a inputBox
        if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            return false;
        }
	});
	

	/***************************************************************************/
	/****************** Progress  Control **************************************/
	/***************************************************************************/
	
	function progress(action,intent) {

		intent = (intent) ? intent.toLowerCase() : '';

		var increment = [0,10,20,30,40,50,60,65,70,75,80,85,87,90,93,94,95,96,97,98,99];
		var num_steps = $(".controls .step-prev").length + 1;
		var pct=increment[num_steps];

		if (intent.search("message.11.yes") != -1)   
			pct=90;
		else if (intent.search("common contact") != -1) 
			pct=95;
		else if (intent.search("evaluate") != -1) 
			pct=100;
		else if(intent.search("slimbot.10.custom form") != -1)
			pct=65;
		else if(intent.search("slimbot.15") != -1)
			pct=100;
		var elem = $(".chat-header  .progress-bar");

		if (pct > 19) 
			$(".powered_by").fadeOut();
		else
			$(".powered_by").fadeIn();


		if (pct > 29 && $('.trigger-header').data('enabled') == 'true' && theme == 'modern')
			$('.trigger-header').last().fadeIn();
		else if (pct > 29 && $('.trigger-header').data('enabled') == 'true')
			$('.trigger-header').fadeIn();
		else if ($('.trigger-header').is(":visible") && $('.trigger-header').data('enabled') == 'true')
			$('.trigger-header').fadeOut();

		elem.css("width",pct+"%");
		elem.text(pct+"%");
	}

	/***************************************************************************/
	/****************** OFF CANVAS MENU   **************************************/
	/***************************************************************************/
	

	$('.header_close').click(function(e) {
        e.preventDefault();
		parent.postMessage("closed_messenger",'*');
	});

	$('.toggle-offcanvas').click(function(e) {
		e.preventDefault();

		var cancelClicked = $(this).hasClass("offcanvas-cancel");

		if (cancelClicked) resetSelectedButton();

		$('.offcanvas-wrapper').toggle();
	});

	function offcanvas_reset() {
		$('#menu-question').val('');
		$('.faq-content-active').removeClass('faq-content-active');
        $('.faq-content-all').addClass('faq-content-active');
        $('.faq-content').hide();
        $('.faq-content-all').show();
        $('.faq-content-footer').show();
        $('.faq_tabbar').css("left",$('.btn-tab-start').data('left'));
        $('.faq_tabbar').css("width",$('.btn-tab-start').data('width'));
        $('.faq_tabbar').show();
        $(".btn-tab-main").show();
        $(".btn-tab-sub").hide();
	}

    $('.faq-tabs .btn-tab-main').click(function(e) {
        e.preventDefault();

		var target=$(this).data('target');
		$(this).focus();

		$('.faq-content-active').removeClass('faq-content-active');
		$("."+target).addClass('faq-content-active');

		$('.faq-content-active').slideDown();
		$('.faq-content').not('.faq-content-active, .faq-content-footer').slideUp();

		$('.faq_tabbar').css({"width": $(this).data('width'),"left": $(this).data('left')});

    });

	//Top Level Catgegory Clicked - Display Submenu
	$('.offcanvas-wrapper').on("click",".btn-main",function(e) {
       	e.preventDefault();

		var target = "." + $(this).attr('data-target');

		var prev = $(target).attr('data-previous');
		$('.btn-tab-sub').attr('data-target',prev);

		$('.faq-content').not(target).slideUp();
		$(target).slideDown();

		showSub();

	});

	
	//Return to previous Page clicked	
	 $('.btn-tab-sub').click(function(e) {
        e.preventDefault();

		var target = "." + $(this).attr('data-target');
		var prev = $(target).data('previous');

		$(target).slideDown();
		$('.faq-content').not($(target)).slideUp();

		if ($(target).hasClass('faq-content-main')) {
			showMain();
		}
		else {
        	$('.btn-tab-sub').attr('data-target',prev);
			showSub();
		}
	});

	function showMain() {
		$('.btn-tab-sub').hide();
		$('.faq_tabbar').show();
		$('.btn-tab-main').show();
		$('.faq-content-footer').show();
		$('.faq-content-active').show();
		$('.faq-content-main').not('.faq-content-active').hide();
	}
	function showSub() {
		$('.btn-tab-sub').show();
		$('.faq_tabbar').hide();
		$('.btn-tab-main').hide();
		$(".btn-tab-sub").focus();
	}

	// Global variable for state if menu has been interacted with.    If it has at least once, then any subsequent click or data entry is
    // a restart so we should clear the messages history
    var restart = false;
	var clearOut = false;

	//Selection Made - Send to Dialogflow
	$('.offcanvas-wrapper').on("click",'.faq-content .btn-link,.faq-content-footer .btn-link', function(e) {
		e.preventDefault();

		if ($(this).hasClass('click-call-trigger'))
			return;

		if ($(this).hasClass('botMenuCategory'))
			return;

		if (!$(this).hasClass('btn-main')) {

			//Use data-postback if exists
			var _postback=($(this).data('postback')) ? $(this).data('postback') : $(this).text();
			var _customBot=($(this).data('custom')) ? $(this).data('custom') : '';
			
			//right here we would want to go to our ajax script and get what we need
			//if _customBot is set we can skip this and go straight to it
			if(_customBot !== ''){
				clearOut = true;
				var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
				var msg = { postback: _postback, display: [ $(this).text() ], custom: _custom, language: language };
				offcanvas_reset();
				$('.offcanvas-wrapper').hide();

				if (restart) {
					$('#message').empty();
				}
				
				if(clearOut){
					$(".step").remove();
					$(".step-container").html('<div class="step step-next"><div class="message"></div></div>');
					$(".enter-to-send").append('<div class="step step-next"><form></form></div>');
				}

				restart = true;
		
				sendMessage(msg);
			}
			else{
				try {
					_MENU_URL=(_URL) ? _URL + "/app/embed/get_mapped_litigation.php" : null;
					if (_MENU_URL) {
						$.ajax({
							type: "POST",
							url: _MENU_URL,
							timeout: 0,
							data: { 
								hash: hash,
								query: _postback
							 },
							success: function(res) {
								console.log(res);
								if(res && res !== '') _customBot = res;
								if( _customBot !== '' )
									var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
								else
									var _custom = { "type": "menuItem", "values": { "item_postback": _postback } };
						
								var msg = { postback: _postback, display: [ $(this).text() ], custom: _custom, language: language };
								offcanvas_reset();
								$('.offcanvas-wrapper').hide();

								if (restart) {
									$('#message').empty();
								}
								
								if(clearOut){
									$(".step").remove();
									$(".step-container").html('<div class="step step-next"><div class="message"></div></div>');
									$(".enter-to-send").append('<div class="step step-next"><form></form></div>');
								}

								restart = true;
						
								sendMessage(msg);
							},
							error: function(xhr,status,error) {
								var errorMessage = xhr.status + ': ' + xhr.statusText + 'app/embed/get_mapped_litigation.php';
								console.log(errorMessage);
								//still send over
								if( _customBot !== '' )
									var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
								else
									var _custom = { "type": "menuItem", "values": { "item_postback": _postback } };
						
								var msg = { postback: _postback, display: [ $(this).text() ], custom: _custom, language: language };
								offcanvas_reset();
								$('.offcanvas-wrapper').hide();

								if (restart) {
									$('#message').empty();
								}
								
								if(clearOut){
									$(".step").remove();
									$(".step-container").html('<div class="step step-next"><div class="message"></div></div>');
									$(".enter-to-send").append('<div class="step step-next"><form></form></div>');
								}

								restart = true;
						
								sendMessage(msg);
							}
						});
					}
					else{
						//still send over
						if( _customBot !== '' )
							var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
						else
							var _custom = { "type": "menuItem", "values": { "item_postback": _postback } };
				
						var msg = { postback: _postback, display: [ $(this).text() ], custom: _custom, language: language };
						offcanvas_reset();
						$('.offcanvas-wrapper').hide();

						if (restart) {
							$('#message').empty();
						}
						
						if(clearOut){
							$(".step").remove();
							$(".step-container").html('<div class="step step-next"><div class="message"></div></div>');
							$(".enter-to-send").append('<div class="step step-next"><form></form></div>');
						}

						restart = true;
				
						sendMessage(msg);
					}
				}
				catch (err) {
					//still send over on a catch but only us the value actually set 
					console.log(err);
					if( _customBot !== '' ){
						clearOut = true;
						var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
					}
					else
						var _custom = { "type": "menuItem", "values": { "item_postback": _postback } };
					
					var msg = { postback: _postback, display: [ $(this).text() ], custom: _custom, language: language };
					offcanvas_reset();
					$('.offcanvas-wrapper').hide();

					if (restart) {
						$('#message').empty();
					}
					
					if(clearOut){
						$(".step").remove();
						$(".step-container").html('<div class="step step-next"><div class="message"></div></div>');
						$(".enter-to-send").append('<div class="step step-next"><form></form></div>');
					}

					restart = true;
			
					sendMessage(msg);
				}
			}
		}
	});

	/***************************************************************/
	/*******************  CONTACT FORM *****************************/
	/***************************************************************/

	emailObj = { 'address': null};
	phoneObj = { 'phone_number': null, 'valid': false};
	var lastPhoneChecked = null;

	//.validate is applied after first validation attempt

	//Full Email Check on Blur
	//$('.controls').on("blur",".contactEmail",function(e) {
		//checkEmail($(this));
	//});

	//Format Only email check on keyup/change
	$('.controls').on("keyup change",".validate",function(e) {
        var thisForm=$(this).closest(".control.contactForm");
		synchronousValidate(thisForm);
    });

	function synchronousValidate(thisForm) {

		var result = true;
		var warningIcon = "<span class='endCheckBox'><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:15px;height:14px'></span></i>";

		if (language == 'es-ES') {
			var errorMsg=warningIcon + " Requerido";
			var consentErrorMsg=warningIcon + " Se requiere casilla de verificación de consentimiento";
			var emailErrorMsg=warningIcon + (($(".contactEmail",thisForm).val()) ? " Se requiere una dirección de correo electrónico válida" : " Requerido");
			var phoneErrorMsg=warningIcon + (($(".contactPhone",thisForm).val()) ? " Se requiere un número de teléfono válido de 10 dígitos" : " Requerido");
		}
		else if (language == 'fr-FR') {
			var errorMsg=warningIcon + " Requis";
			var consentErrorMsg=warningIcon + " Case à cocher de consentement requise";
			var emailErrorMsg=warningIcon + (($(".contactEmail",thisForm).val()) ? " Adresse e-mail valide requise" : " Requis");
			var phoneErrorMsg=warningIcon + (($(".contactPhone",thisForm).val()) ? " Numéro de téléphone valide à 10 chiffres requis" : " Requis");
		}
		else {
			var errorMsg=warningIcon + " Required";
			var consentErrorMsg=warningIcon + " Consent Checkbox Required";
			var emailErrorMsg=warningIcon + (($(".contactEmail",thisForm).val()) ? " Valid email address required" : " Required");
			var phoneErrorMsg=warningIcon + (($(".contactPhone",thisForm).val()) ? " Valid 10 digit phone number required" : " Required");
		}

		var singleFields = [];
		if ($(".contactFname",thisForm).length) singleFields.push($(".contactFname",thisForm));
		if ($(".contactLname",thisForm).length) singleFields.push($(".contactLname",thisForm));
		if ($(".contactRelativeFname",thisForm).length) singleFields.push($(".contactRelativeFname",thisForm));
		if ($(".contactRelativeLname",thisForm).length) singleFields.push($(".contactRelativeLname",thisForm));
		if ($(".contactState",thisForm).length) singleFields.push($(".contactState",thisForm));
		if ($(".contactCity",thisForm).length) singleFields.push($(".contactCity",thisForm));
		if ($(".contactZip",thisForm).length) singleFields.push($(".contactZip",thisForm));
		if ($(".contactEmail2",thisForm).length) singleFields.push($(".contactEmail2",thisForm));
		if ($(".contactPhone2",thisForm).length) singleFields.push($(".contactPhone2",thisForm));
		if ($(".contactCaseType",thisForm).length) singleFields.push($(".contactCaseType",thisForm));
		if ($(".contactEmergencyContact",thisForm).length) singleFields.push($(".contactEmergencyContact",thisForm));
		if ($(".contactIncidentDate",thisForm).length) singleFields.push($(".contactIncidentDate",thisForm));
		if ($(".contactBirthday",thisForm).length) singleFields.push($(".contactBirthday",thisForm));
		if ($(".contactSummary",thisForm).length) singleFields.push($(".contactSummary",thisForm));

		for (var i=0;i<singleFields.length;i++) {		
			var curElem = singleFields[i];
			
			if(curElem.hasClass('contactZip') && curElem.val()){
				//make sure that the max length and stuff is good
				if (language == 'es-ES') {
					var zipErrorMessage=warningIcon + " El código postal debe tener 5 dígitos."
				}
				else if (language == 'fr-FR') {
					var zipErrorMessage=warningIcon + " Le code postal doit être composé de 5 chiffres."
				}
				else {
					var zipErrorMessage=warningIcon + " Zip must be 5 digits."
				}
				
				var minlength = (curElem.attr('data-minlength')) ? curElem.attr('data-minlength') : '0';
				var maxlength = (curElem.attr('data-maxlength')) ? curElem.attr('data-maxlength') : '999';
				if(curElem.val().length < minlength || curElem.val().length > maxlength ){
					curElem.addClass("validate error").next('.errorLabel').html(zipErrorMessage).show();
					result = false;
				}
			}
			else if (!curElem.val()) {
				curElem.addClass("validate error").next('.errorLabel').html(errorMsg).show();
				result = false;
			}
			else {
				curElem.removeClass("error").next('.errorLabel').hide();
			}
		}

		//var emailValue = $(".contactEmail",thisForm).val();

		var validPhoneFormat = ($(".contactPhone",thisForm).length > 0) ? isValidPhoneNumberFormat($(".contactPhone",thisForm).val()) : true;
		var validEmailFormat = ($(".contactEmail",thisForm).length > 0) ? isValidEmailAddressFormat($(".contactEmail",thisForm).val()) : true;

		if (!validEmailFormat && !validPhoneFormat) { //Both email and phone invalid
           	$(".contactEmail",thisForm).addClass("validate error").next('.errorLabel').html(emailErrorMsg).show();
           	$(".contactPhone",thisForm).addClass("validate error").next('.errorLabel').html(phoneErrorMsg).show();
			result = false;
        }
		else if (validEmailFormat && $(".contactPhone",thisForm).val() && !validPhoneFormat) { //Phone invalid but not empty
			$(".contactEmail",thisForm).removeClass("error").next('.errorLabel').hide();
			$(".contactPhone",thisForm).addClass("validate error").next('.errorLabel').html(phoneErrorMsg).show();
			result = false;
		}
		else if (validEmailFormat && !$(".contactPhone",thisForm).val() && requirePhone && $(".contactPhone",thisForm).length > 0) { //Phone required but empty
			$(".contactEmail",thisForm).removeClass("error").next('.errorLabel').hide();
			$(".contactPhone",thisForm).addClass("validate error").next('.errorLabel').html(phoneErrorMsg).show();
			result = false;
		}
		else if (validPhoneFormat && $(".contactEmail",thisForm).val() && !validEmailFormat) { //Email invalid but not empty
            $(".contactPhone",thisForm).removeClass("error").next('.errorLabel').hide();
           	$(".contactEmail",thisForm).addClass("validate error").next('.errorLabel').html(emailErrorMsg).show();
			result = false;
		}
		else if (validPhoneFormat && !$(".contactEmail",thisForm).val() && requireEmail && $(".contactEmail",thisForm).length > 0) {  //Email requried but empty
            $(".contactPhone",thisForm).removeClass("error").next('.errorLabel').hide();
           	$(".contactEmail",thisForm).addClass("validate error").next('.errorLabel').html(emailErrorMsg).show();
			result = false;
		}
        else { //Email / phone validation passes
            $(".contactEmail",thisForm).removeClass("error").next('.errorLabel').hide();
            $(".contactPhone",thisForm).removeClass("error").next('.errorLabel').hide();
		}
			
	
/*
		if ($('.consent2Button').length) {
			if (!$(".consentButton",thisForm).hasClass('checked') || !$(".consent2Button",thisForm).hasClass('checked')) {
				$(".consentErrorLabel",thisForm).html(consentErrorMsg).show();
				result = false;
			}
			else {
				$(".consentErrorLabel",thisForm).hide();
			}
		}
		else {
			if (!$(".consentButton",thisForm).hasClass('checked')) {
				$(".consentErrorLabel",thisForm).html(consentErrorMsg).show();
				result = false;
			}
			else {
				$(".consentErrorLabel",thisForm).hide();
			}
		}
*/

		if ($('.consent2Button',thisForm).length) {
			if (!$(".consentButton",thisForm).hasClass('checked') || !$(".consent2Button",thisForm).hasClass('checked')) {
				$(".consentErrorLabel",thisForm).html(consentErrorMsg).show();
				result = false;
			}
			else {
				$(".consentErrorLabel",thisForm).hide();
			}
		}
		else if ($('.consentButton',thisForm).length) {
			if (!$(".consentButton",thisForm).hasClass('checked')) {
				$(".consentErrorLabel",thisForm).html(consentErrorMsg).show();
				result = false;
			}
			else {
				$(".consentErrorLabel",thisForm).hide();
			}
		}
		else {
			$(".consentErrorLabel",thisForm).hide();
		}

		return result;
	}

	function emailServiceRequest(addr) {

		//If this address has already been validated do not check again - if no address also return
		if ((emailObj.hasOwnProperty('address') && emailObj.address == addr) || !addr) 
			return [emailObj];  //return array since that is what an ajax response is

		_EMAIL_VALIDATION_URL=(_URL) ? _URL + "/app/embed/mailgunValidateAjax.php" : null;
		return $.ajax({
			"url": _EMAIL_VALIDATION_URL,
			"data": { address: addr, case_id: caseIdGlobal },
			"dataType": 'json',
			"type": "POST",
			"timeout": 3000
		});
	}

	function phoneServiceRequest(num) {
        if (lastPhoneChecked == num)
            return [phoneObj];

        lastPhoneChecked = num;

        _PHONE_VALIDATION_URL=(_URL) ? _URL + "/app/embed/twilioValidateAjax.php" : null;
        return $.ajax({
            "url": _PHONE_VALIDATION_URL,
            "data": { phone: num, case_id: caseIdGlobal },
            "dataType": 'json',
            "type": "POST",
			"timeout": 3000
        });
    }

	$('.controls').on("keydown",".form-control",function(e) {
        //Prevents Enter key from submitting on contact form
        if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            return false;
        }
    });


	$('.controls').on("click",".contact-btnWrapper .btn",function(e) {


		var thisForm=$(this).closest(".control.contactForm");
		var emailField = $(".contactEmail",thisForm);
		var phoneField = $(".contactPhone",thisForm);

		//Get targetId for custom bot and assign value to thisForm
		var _targetId = $(this).data("target");
		thisForm.data("target", _targetId);

		synchronousValidated = synchronousValidate(thisForm);  //simple field validation

		if (!synchronousValidated) return;

		//Disable submit button during processing.  Switched to buttonSelected so disabling would work with custom bot
		buttonSelected($(this));
		//disableSubmitButton($(this));

		if (!validateService || (emailField.length == 0 && phoneField.length == 0)) {
			submitLeadForm(thisForm);  //Submit if validation service is off
			return;
		}

		var promises = [];

		//Call Email or Phone promise functions only when they are not undefined.
		if (emailField.val() !== undefined) {
			promises.push(emailServiceRequest(emailField.val())); //Add emailServiceRequest function to promise array
		} 
		else {
			promises.push($.Deferred().resolve(null)); // Add a resolved promise with null if no email
		}

		if (phoneField.val() !== undefined) {
			promises.push(phoneServiceRequest(phoneField.val())); //Add phoneServiceRequest function to promise array
		} 
		else {
			promises.push($.Deferred().resolve(null)); // Add a resolved promise with null if no phone
		}

		//The following will execute the functions that were pushed to the promises array. 
		$.when.apply($, promises)	
        .then(function(emailResponse, phoneResponse) {

			// If emailResponse/phoneResponse is null then those fields were not present on the form.
			emailObj = emailResponse ? emailResponse[0] : {'address': null};
			phoneObj = phoneResponse ? phoneResponse[0] : {'phone_number': null, 'valid': true};

//			console.log(emailObj);
//			console.log(phoneObj);

			handleFinalCheck(thisForm);

		})
		.fail( function( reason ) {
            // Submit anyway on any error - dont want ajax timeouts to block submissions
            submitLeadForm(thisForm);  
        })

	});

	function handleFinalCheck(thisForm) {

		var emailField = $(".contactEmail",thisForm);
		var phoneField = $(".contactPhone",thisForm);
		var emailGood = true;
		var phoneGood = true;

		emailObj.result = (emailObj.hasOwnProperty('result')) ? emailObj.result : null;
       	emailObj.risk = (emailObj.hasOwnProperty('risk')) ? emailObj.risk : null;
       	emailObj.did_you_mean = (emailObj.hasOwnProperty('did_you_mean')) ? emailObj.did_you_mean : null;
       	emailObj.is_disposable_address = (emailObj.hasOwnProperty('is_disposable_address')) ? emailObj.is_disposable_address : null;
       	emailObj.is_role_address = (emailObj.hasOwnProperty('is_role_address')) ? emailObj.is_role_address : null;
	
   		var emailMsg = '';
   		var warningIcon = "<span><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:14px;height:13px'></span></i>";

		/*
   		if (emailObj.did_you_mean)
       		emailMsg = warningIcon + "Did you mean " + emailObj.did_you_mean + "?";
      	else
       		emailMsg = warningIcon + "Please enter a valid email";
		*/
		emailMsg = warningIcon + "Valid email address required";

      	if (emailObj.result == "undeliverable" || emailObj.result == "do not send" || emailObj.risk == 'high') {
			emailGood = false;
        	emailField.addClass("validate error").next('.errorLabel').html(emailMsg).show();
		}

		// There is a known bug when checking an empty phone number.  phoneObj.valid will be false requring a phone number. ** WL 8/21/24 **
		// This is not the case for email address. The bug was not fixed since firms that already have extra validation enabled were always getting phone numbers.
		if (!phoneObj.valid) {
            phoneGood = false;
			phoneMsg = warningIcon + "Please enter a valid phone number";
            phoneField.addClass("validate error").next('.errorLabel').html(phoneMsg).show();
        }

		if (emailGood && phoneGood) {
			submitLeadForm(thisForm);	
		}
		else {
			//Re-enable button.  Switched to resetSelectedButton so enabling a button would work with custom bot
			resetSelectedButton();
			//enableSubmitButton($(".contact-btnWrapper .btn",thisForm));
      	}

		//return false;
	};

	function submitLeadForm(form2Submit) {
		var _custom = {}
		var values = {}

		thisForm = form2Submit;

		if ($(".contactFname",thisForm).val())
			values.fname = $(".contactFname",thisForm).val();
		if ($(".contactLname",thisForm).val())
			values.lname = $(".contactLname",thisForm).val();
		if ($(".contactSuffix",thisForm).val())
			values.suffix = $(".contactSuffix",thisForm).val();
		if ($(".contactRelativeFname",thisForm).val())
			values.relativeFname = $(".contactRelativeFname",thisForm).val();
		if ($(".contactRelativeLname",thisForm).val())
			values.relativeLname = $(".contactRelativeLname",thisForm).val();
		if ($(".contactRelativeSuffix",thisForm).val())
			values.relativeSuffix = $(".contactRelativeSuffix",thisForm).val();
		if ($(".contactEmail",thisForm).val())
			values.email = $(".contactEmail",thisForm).val();
		if ($(".contactPhone",thisForm).val())
			values.phone = $(".contactPhone",thisForm).val();
		if ($(".contactState",thisForm).val())
			values.state = $(".contactState",thisForm).val();
		if ($(".contactCity",thisForm).val())
			values.city = $(".contactCity",thisForm).val();
		if ($(".contactZip",thisForm).val())
			values.zip = $(".contactZip",thisForm).val();
		if ($(".contactEmail2",thisForm).val())
			values.email2 = $(".contactEmail2",thisForm).val();
		if ($(".contactPhone2",thisForm).val())
			values.phone2 = $(".contactPhone2",thisForm).val();
		if ($(".contactStreet",thisForm).val())
			values.street = $(".contactStreet",thisForm).val();
		if ($(".contactEmergencyContact",thisForm).val())
			values.emergencyContact = $(".contactEmergencyContact",thisForm).val();
		if ($(".contactCaseType",thisForm).val()){
			values.generalCaseType = $(".contactCaseType",thisForm).val();
			values.generalCaseTypeName = $(".contactCaseType",thisForm).find(':selected').data('name');
		}
		if ($(".contactSummary",thisForm).val())
			values.summary = $(".contactSummary",thisForm).val();
		if ($(".contactBirthday",thisForm).val())
			values.dateOfBirth = $(".contactBirthday",thisForm).val();
		if ($(".contactIncidentDate",thisForm).val())
			values.incidentDate = $(".contactIncidentDate",thisForm).val();

		if ($(".nodetype",thisForm).val()) {
			_custom.nodetype = $(".nodetype",thisForm).val();
		}

		var _targetId = $(thisForm).data("target");

		_custom.type= "contactForm";
		_custom.values = values;

		var msg = { postback: "contact form submission", custom: _custom, language: language, target: _targetId };

		//console.log(JSON.stringify(msg));
		sendMessage(msg);

		parent.postMessage(values,'*');

	}

	function disableSubmitButton(submitBtn) {
		submitBtn.attr('disabled',true);
		//$(".btn-previous,.btn-restart").attr('disabled',true);
		submitBtn.data('orig-text',submitBtn.html());
		submitBtn.html('<span><img src="./lib/fontawesome/svgs/regular/spinner.svg" class="spinIcon" style="filter: invert(100%) sepia(12%) saturate(7496%) hue-rotate(289deg) brightness(118%) contrast(103%);width:22px;height22px"></span>');
	}

	function enableSubmitButton(submitBtn) {
		 submitBtn.removeAttr('disabled');
         //$(".btn-previous,.btn-restart").removeAttr('disabled');
         var orig_text = submitBtn.data('orig-text');
         submitBtn.html(orig_text);
	}

	$('.controls').on('click','.consentButton, .consent2Button',function(e) {
		var warningIcon = "<span class='endCheckBox'><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:15px;height:14px'></span></i>";
		
		if (language == 'es-ES') {
			var errorMsg=warningIcon + " Requerido";
			var consentErrorMsg=warningIcon + " Se requiere casilla de verificación de consentimiento";
		}
		else if (language == 'fr-FR') {
			var errorMsg=warningIcon + " Requis";
			var consentErrorMsg=warningIcon + " Case à cocher de consentement requise";
		}
		else {
			var errorMsg=warningIcon + " Required";
			var consentErrorMsg=warningIcon + " Consent Checkbox Required";
		}

		var thisForm=$(this).closest(".control.contactForm");
		if ($('.consent2Button',thisForm).length) {
			if (!$(".consentButton",thisForm).hasClass('checked') || !$(".consent2Button",thisForm).hasClass('checked')) {
				$(".consentErrorLabel",thisForm).html(consentErrorMsg).show();
			}
			else {
				$(".consentErrorLabel",thisForm).hide();
			}
		}
		else {
			if (!$(".consentButton",thisForm).hasClass('checked')) {
				$(".consentErrorLabel",thisForm).html(consentErrorMsg).show();
			}
			else {
				$(".consentErrorLabel",thisForm).hide();
			}
		}
	});

	$('.controls').on('click','.policyButton',function(e) {
		window.open('https://simplyconvert.com/privacy-policy');
	});
	$('.click-call-consent').on('click','.policyButton',function(e) {
		window.open('https://simplyconvert.com/privacy/privacy-highlights.php');
	});
	$('.controls').on('click','.termsButton',function(e) {
		window.open('https://simplyconvert.com/terms-and-conditions');
	});

	/****************************************************************/
	/****************** FREEFORM QUERY FROM OFFCANVAS MENU **********/
	/****************************************************************/

	$('#menu-form').keydown(function(e) {
        if (e.keyCode == 13 && !e.shiftKey) {
			e.preventDefault();
            $('#menu-form').submit(); 
            return false;
        }
    });

	$('#menu-form').submit(function(e) {
        e.preventDefault();

		//need to customize here to go to custom bots if set
		var postbackText = $('#menu-question').val();
		var _customBot = '';
		
		if (postbackText) {
			try{
				_MENU_URL=(_URL) ? _URL + "/app/embed/get_mapped_litigation.php" : null;
				if (_MENU_URL) {
					$.ajax({
						type: "POST",
						url: _MENU_URL,
						timeout: 0,
						data: { 
							hash: hash,
							query: postbackText
							},
						success: function(res) {
							if(res && res !== '') _customBot = res;
							if( _customBot !== '' )
								var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
							else
								var _custom = { "type": "menuItem", "values": { "user query": postbackText } };
							
							$('.offcanvas-text').blur();
        					var msg = { postback: postbackText, custom: _custom, language: language };
					
							$('.offcanvas-wrapper').hide();
							offcanvas_reset();

							sendMessage(msg);
							dataLayer.push({'event': 'menuquestion_submit'});
						},
						error: function(xhr,status,error) {
							var errorMessage = xhr.status + ': ' + xhr.statusText + 'app/embed/get_mapped_litigation.php';
							console.log(errorMessage);
							//still send over
							var _custom = { "type": "menuItem", "values": { "user query": postbackText } };

        					$('.offcanvas-text').blur();
							var msg = { postback: postbackText, custom: _custom, language: language };
					
							$('.offcanvas-wrapper').hide();
							offcanvas_reset();

							sendMessage(msg);
							dataLayer.push({'event': 'menuquestion_submit'});
						}
					});
				}
				else{
					//still send over
					if( _customBot !== '' )
						var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
					else
						var _custom = { "type": "menuItem", "values": { "user query": postbackText } };
					
					$('.offcanvas-text').blur();
					var msg = { postback: postbackText, custom: _custom, language: language };
			
					$('.offcanvas-wrapper').hide();
					offcanvas_reset();

					sendMessage(msg);
					dataLayer.push({'event': 'menuquestion_submit'});
				}
			}
			catch (err) {
				//still send over on a catch but only us the value actually set 
				console.log(err);
				if( _customBot !== '' ){
					var _custom = { "type": "menuItem", "values": { "custom_bot_id": _customBot } };
				}
				else
					var _custom = { "type": "menuItem", "values": { "user query": postbackText } };
			
				$('.offcanvas-text').blur();
				var msg = { postback: postbackText, custom: _custom, language: language };
		
				$('.offcanvas-wrapper').hide();
				offcanvas_reset();

				sendMessage(msg);
				dataLayer.push({'event': 'menuquestion_submit'});
			}

		}
		return false;
    });

	/****************************************************************/
	/********* COMPOSER /  TEXTAREA *********************************/
	/****************************************************************/

	function toggleComposer(elem) {
		if ($('.controls .step-active').find('.control-default').length !== 0)
			showComposer();
		else
			hideComposer();
	}

	function showComposer() {
		//Setting maxLength on the textarea control to prevent extra text
		// Adding 1 to maxLength so the character counter error message will show
		maxTextLength = getMaxTextLength();
		$(".control-textarea").prop('maxLength', maxTextLength + 1);

		$(".control-textarea-wrapper").show();
		$(".controls .step-active").hide();
		$("body").addClass("composer-visible");
		$(".control-textarea",".controls").val($(".step-active .control-default").html()); //Restore Value for previous
		setTimeout(function() {
			$(".desktop .controls .control-textarea").focus();
		}, 500);
			
	}

	function hideComposer() {
		$("body").removeClass("composer-visible");
		$(".controls .step-active").show();
		$(".control-textarea-wrapper").hide();
		document.activeElement.blur();
	}

	// Function returns the maxTextLength for the textarea control based off the name of the intent
	function getMaxTextLength() {
		if (intent.indexOf("notes") !== -1 || intent.indexOf("message.") !== -1) {
			return _MAX_CHARACTER_LONG;
		}
		else if (intent.indexOf("message_ending") !== -1) {
			return _MAX_CHARACTER_MEDIUM;
		}
		else {
			return _MAX_CHARACTER_SHORT;
		}
	}

	//IOS does not blue when touch outside active element
	/*
	$('body').on("touchstart", function(e) {

		if(!$(e.target).parents('.controls').length)
			document.activeElement.blur();
	});
	*/

	$('.desktop .controls').on("click",function(e) {
		if ($(".control-textarea").is(":focus"))
			return;
		else
			$(".control-textarea").focus();
    });

	$('.desktop .controls .control-textarea').on("focusin",function(e) {
		$('.controls').addClass("focused");
    });

    $('.controls').on("blur",".control-textarea", function(e) {
		$('.controls').removeClass("focused error");
    });

	function submitComposer() {
		var postbackText = $('.control-textarea').val();
		var postbackTextLength = postbackText.length;
		maxTextLength = getMaxTextLength();

		// Get target id for custom bot from the response-text
		var targetId = $(".step-active .response .response-text",".step-container").data("target");
		
		if (!postbackText || (postbackTextLength > maxTextLength)) {
			$(".controls").addClass("error");
			return false;
		}
		
		//Remove character counter	
		$(".char-counter, .modern-char-counter").addClass("d-none");

		buttonSelected($(".btn-composer"));	
		$(".step-active .control-default",".controls").html(postbackText);
		var msg = { postback: postbackText, language: language, target: targetId };
		sendMessage(msg);
		$('.control-textarea').val('').css('height','');
	}

   	//If Enter pressed then submit the text
	$('.controls').on("keydown",".control-textarea",function(e) {
		if (e.keyCode == 13 && !e.shiftKey) {
             e.preventDefault();
             submitComposer();
             return false;
		}
	});


	//If Enter pressed then do nothing.  The keydown function will submit the text
	//If any other key is pressed start the character counter
    $('.controls').on("keyup",".control-textarea",function(e) {
		//If enter is pressed then do nothing else execute character counter
		if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
			return false;
        }
		else {
			var textCount = $(this).val().length;
			var warningIcon = "<span class='endCheckBox'><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:15px;height:14px'></span>";
			maxTextLength = getMaxTextLength();

			if(textCount > maxTextLength) {
				if (language == 'es-ES') {
					var errorMsgTextlength = warningIcon + " El texto debe tener " + maxTextLength + " caracteres o menos";
				}
				else if (language == 'fr-FR') {
					var errorMsgTextlength = warningIcon + " Le texte doit comporter " + maxTextLength + " caractères ou moins";
				}
				else {
					var errorMsgTextlength = warningIcon + " Text has to be " + maxTextLength + " characters or less";
				}
				$(".char-counter, .modern-char-counter").addClass("d-none");
				if (theme == 'modern') {
					$(".modern-character-warning").removeClass("d-none").html(errorMsgTextlength);
				}
				else {
					$(".character-warning").removeClass("d-none").html(errorMsgTextlength);
				}
			}
			else{
				var characterCount = textCount + "/" + maxTextLength;
				$(".character-warning, .modern-character-warning").addClass("d-none");
				if (theme == 'modern') {
					$(".modern-char-counter").removeClass("d-none").html(characterCount);
				}
				else {
					$(".char-counter").removeClass("d-none").html(characterCount);
				}
			}
		}
	});

	//Button clicked
	$('.controls').on("click",".btn-composer",function(e) {
		e.preventDefault();
		//buttonSelected($(this));
		submitComposer();
    });

	//Auto expand 	
	$('.controls').on("input",".control-textarea",function(e) {
		if ($(this).val()) $(".controls").removeClass("error");
		field = e.target;
		field.style.height = 'inherit';
		field.style.height = field.scrollHeight + 'px';
		$('.messages').scrollTop($('.messages')[0].scrollHeight);
    });

	/***********************************************************/
	/***  Restart link clicked                              ****/
	/***********************************************************/

	function restart_bot() {
		$(".step").remove();

		$(".step-container").html('<div class="step step-next"><div class="message"></div></div>');
        $(".enter-to-send").append('<div class="step step-next"><form></form></div>');

		if (language == 'en-US') {
			var _display = ['restart'];
		}
		else if (language == 'es-ES') {
			var _display = ['reiniciar'];
		}
		else if (language == 'fr-FR') {
			var _display = ['redémarrer'];
		}

		var msg = { postback: "restart", display: _display, language: language };
		sendMessage(msg);
		return false;
	}

	$('.chat-header').on("click",".btn-restart",function(e) {
		restart_bot();
	});

	/**********************************************************/
	/****** Button disabling/ re-enabling ********************/
	/**********************************************************/

	var selectedButton = '';

	function resetSelectedButton() {

        if (selectedButton) {
        	var thisForm = selectedButton.closest("form");

        	$(".btn-composer .spinner").hide();
        	$(".btn-composer .btn-composer-submit").show();
			$(".statusIcon",selectedButton).html('<span><img src="./lib/fontawesome/svgs/regular/chevron-right.svg" style="filter: invert(100%) sepia(12%) saturate(7496%) hue-rotate(289deg) brightness(118%) contrast(103%);width:8px;height16px"></span>');
			selectedButton.removeClass("active");
			$(".btn",thisForm).removeAttr('disabled');
			$(".btn-previous,.btn-restart").removeAttr('disabled');
		}
		selectedButton = '';
    }

    function buttonSelected(_btn) {
        selectedButton = _btn;
        var thisForm = _btn.closest("form");
		$(".btn",thisForm).attr('disabled',true);
		$(".btn-previous,.btn-restart").attr('disabled',true);
		_btn.addClass("active");
		$(".statusIcon",_btn).html('<span><img src="./lib/fontawesome/svgs/regular/spinner.svg" class="spinIcon" style="filter: invert(100%) sepia(12%) saturate(7496%) hue-rotate(289deg) brightness(118%) contrast(103%);width:22px;height:22px"></span>');
        $(".btn-composer .btn-composer-submit").hide();
        $(".btn-composer .spinner").show();
	
    }


	/*********************************************************/
    /**************  Date Select Button Submit ***************/
    /*********************************************************/

    $('.controls').on("click",".dateSelect button",function(e) {

		buttonSelected($(this));

		var thisControl = $(this).closest('.control.dateSelect');
		var targetId = $(this).data("target");
		var _postbackType = $(this).data("postbacktype");
		var _postbackTag = $(this).data("postbacktag");
		 
		var month = $('select[name=_month] option:selected',thisControl).val();
		var day = $('select[name=_day] option:selected',thisControl).val();
		var year = $('select[name=_year] option:selected',thisControl).val();
		var monthDisplay = $('select[name=_month] option:selected',thisControl).text();
		var dayDisplay = $('select[name=_day] option:selected',thisControl).text();
		var yearDisplay = $('select[name=_year] option:selected',thisControl).text();

		var display = [];

		month = (month) ? month : '';
		day = (day) ? day : '';
		year = (year) ? year : '';

		var postback = month + " " + day + " " + year;
		display.push(monthDisplay + " " + dayDisplay + " " + yearDisplay);

		sendMessage({ postback: postback, display: display, language: language, target: targetId, postbackType: _postbackType, postbackTag: _postbackTag });

		return false;
	});

	/*********************************************************/
    /************  Relationship Form Submit ******************/
    /*********************************************************/

	var requireRelativeName = '';

	$('.controls').on("click",".control.relationship .select-btnWrapper .btn",function(e) {

		requireRelativeName = false;

		var display = [];
		var _custom = {}
		var values = {}

		var thisControl = $(this).closest('.control.relationship');

		buttonSelected($(this));

		var relation = $(".radio-relation .btn.checked",thisControl).data("postback");
		var relationDisplay = $(".radio-relation .btn.checked",thisControl).data("display");
		var targetId = $(".radio-relation .btn.checked",thisControl).data("target");

		var deceased = $(".radio-deceased .btn.checked:visible",thisControl).data("postback");
		var deceasedDisplay = $(".radio-deceased .btn.checked:visible",thisControl).data("display");

		var month = $('select[name=_month]:visible option:selected',thisControl).val();
		var day = $('select[name=_day]:visible option:selected',thisControl).val();
		var year = $('select[name=_year]:visible option:selected',thisControl).val();
		var monthDisplay = $('select[name=_month]:visible option:selected',thisControl).text();
		var dayDisplay = $('select[name=_day]:visible option:selected',thisControl).text();
		var yearDisplay = $('select[name=_year]:visible option:selected',thisControl).text();

		month = (month) ? month : '';
        day = (day) ? day : '';
        year = (year) ? year : '';

        var dod = month + " " + day + " " + year;
        var dod_display = monthDisplay + " " + dayDisplay + " " + yearDisplay;

		display.push(relationDisplay);
		values.relation = relation;

		if ($("input[name='requireRelativeName']").val() == 1 && relation != "Myself") { requireRelativeName = true; }

		if (deceased) {
			display.push(deceasedDisplay);
			values.deceased = deceased;
		}

		if (month || day || year) {
			//display.push("Date of death: " + dod);
			display.push(dod_display);
			values.dod = dod;
		}

		values.requireRelativeName = requireRelativeName;

		_custom.type= "relationForm";
		_custom.values = values;

		var msg = { postback: relation, display: display, custom: _custom, language: language, target: targetId };

		sendMessage(msg);

	});

	/*********************************************************/
    /************  Single Select Button Submit ***************/
    /*********************************************************/


	 $('.controls').on("click",".select button",function(e) {
		buttonSelected($(this));

		var thisControl = $(this).closest('form');
        
        var postback = '';
        var display = [];
		var _targetId = ($(".control select option:selected",thisControl).data('target'));
		var _postbackId = ($(".control select option:selected",thisControl).data('postbackid'));
		var _postbackType = ($(".control select option:selected",thisControl).data('postbacktype'));
		var _litigation = ($(".control select option:selected",thisControl).data('litigation'));
		var _postbackTag = ($(".control select option:selected",thisControl).data('postbacktag'));
		
		if($('#selectControlID', thisControl).length > 0){
			//override values here
			_targetId = ($(".selected-option",thisControl).data('target'));
			_postbackId = ($(".selected-option",thisControl).data('postbackid'));
			_postbackType = ($(".selected-option",thisControl).data('postbacktype'));
			_litigation = ($(".selected-option",thisControl).data('litigation'));
			_postbackTag = ($(".selected-option",thisControl).data('postbacktag'));
			postback = $('#selectControlID', thisControl).val();
			display.push($(".selected-option",thisControl).data('display'));
		}
		else{
			postback = $(".control select",thisControl).val();
			display.push($(".control select option:selected",thisControl).data('display'));
		}

		sendMessage({ postback: postback, display: display, language: language, target: _targetId, postbackId: _postbackId, postbackType: _postbackType, postbackTag: _postbackTag, litigation: _litigation });

        return false;
    });

	/*********************************************************/
    /************  County Select Button Submit ***************/
    /*********************************************************/


	 $('.controls').on("click",".countySelect button",function(e) {
		buttonSelected($(this));

		var thisControl = $(this).closest('form');
        
        var postback = '';
        var display = [];
		postback = $(".stateCounty").val() + ", " + $(".county").val() ; 
		display.push($(".county option:selected").data('display'));
		display.push($(".stateCounty option:selected").data('display'));
		var _targetId = $(this).data('target');
		var _postbackType = (_targetId == undefined || _targetId == '') ? '' : 'county'; 
		sendMessage({ postback: postback, display: display, language: language, target: _targetId, postbackType: _postbackType });

        return false;
    });

	/*********************************************************/
    /************  Multiple Select Button Submit *************/
    /*********************************************************/

	$('.controls').on("click",".multipleSelect .select-btnWrapper button,.radioSelect .select-btnWrapper button",function(e) {
		buttonSelected($(this));

		var thisControl = $(this).closest('.control');

		//Multiple Select
        var postback = '';
        var display = [];
		var _postbackId = [];
		var _postbackType = [];
		var _litigation = ''; //only taking first one
		var _postbackTag = [];
        var selection = $(".btn.checked",thisControl).each(function() {
            postback += (postback != '') ? " " : '';
            postback += $(this).data('postback');
			display.push($(this).data('display'));
			_postbackType.push($(this).data('postbacktype'));
			_postbackId.push($(this).data('postbackid'));
			_postbackTag.push($(this).data('postbacktag'));
			if(_litigation == '' || _litigation == undefined) _litigation = $(this).data('litigation'); 
            _targetId = $(this).data('target');
        });

		sendMessage({ postback: postback, display: display, language: language, target: _targetId, postbackId: _postbackId, postbackType: _postbackType, postbackTag: _postbackTag, litigation: _litigation });

        return false;
    });

	$('.controls').on("click",".multiRadio .select-btnWrapper button",function(e) {
		buttonSelected($(this));

		//radioSelects
        var postback = '';
        var display = [];
		var question = [];
        var radioSelects = $("input:radio:checked").each(function(){
			var name = $(this).attr('name');
			//only looked at the checked fields
			var radioGroup = $(this).closest('.radioGroup');
			
			if(!radioGroup.hasClass('d-none')){
				question.push($(this).data('question'));
				display.push($(this).data('display'));
				postback += (postback != '') ? " " : '';
				postback += $(this).val();
			}
		});

		var dateSelects = $(".radioDateOption").each(function(){
			var month = $('select[name=_month] option:selected',$(this)).val();
			var day = $('select[name=_day] option:selected',$(this)).val();
			var year = $('select[name=_year] option:selected',$(this)).val();
			var monthDisplay = $('select[name=_month] option:selected',$(this)).text();
			var dayDisplay = $('select[name=_day] option:selected',$(this)).text();
			var yearDisplay = $('select[name=_year] option:selected',$(this)).text();

			month = (month) ? month : '';
			day = (day) ? day : '';
			year = (year) ? year : '';
			
			postback += (postback != '') ? " " : '';
			postback += month + " " + day + " " + year;
			var radioGroup = $(this).closest('.radioGroup');
			if(!radioGroup.hasClass('d-none')){
				question.push($(this).data('question'));
				display.push(monthDisplay + " " + dayDisplay + " " + yearDisplay);
			}
		});
		sendMessage({ postback: postback, display: display, language: language, question: question });

        return false;
    });

	/*********************************************************/
    /*************** Image and Video Button Submit ***********/
    /*********************************************************/
	$('.controls').on("click",".image-submit .select-btnWrapper button, .video-submit .select-btnWrapper button",function(e) {
		buttonSelected($(this));

		//Stop the video when the submit button is clicked
		if ($('.control').hasClass('video-submit')) {
			var muxPlayer = document.querySelector("mux-player");
			muxPlayer.pause();
		}

        var postback = '';
        var display = [];
		var targetId = $(this).data("target");
		postback = $(this).data("postback");
		display.push($(this).data("display"));

		sendMessage({ postback: postback, display: display, language: language, target: targetId });
	});

	/*********************************************************/
    /********************  Input Box Button Submit ***********/
    /*********************************************************/


	 $('.controls').on("click",".inputBox button",function(e) {
		
		var thisControl = $(this).closest('form');
		var minlength = ($(".control input",thisControl).attr('data-minlength')) ? $(".control input",thisControl).attr('data-minlength') : '0';
		var maxlength = ($(".control input",thisControl).attr('data-maxlength')) ? $(".control input",thisControl).attr('data-maxlength') : '999';
		var inputType = ($(".control input",thisControl).attr('type'));

		var warningIcon = "<span class='endCheckBox'><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:15px;height:14px'></span></i>";
		var errorMsg=warningIcon + " Required";

		// Set errorMsgMinlength based on inputType and the values of minlength and maxlength
		if (inputType == 'number') {
			var errorMsgMinlength = (minlength == maxlength) ? warningIcon + " Number has to be " + minlength + " digits" : warningIcon + " Number has to be " + minlength + " digits or more";
			var errorMsgMaxlength = (minlength == maxlength) ? warningIcon + " Number has to be " + maxlength + " digits" : warningIcon + " Number has to be " + maxlength + " digits or less";
		}
		else {
			var errorMsgMinlength = (minlength == maxlength) ? warningIcon + " Text has to be " + minlength + " characters" : warningIcon + " Text has to be " + minlength + " characters or more";
			var errorMsgMaxlength = (minlength == maxlength) ? warningIcon + " Text has to be " + maxlength + " characters" : warningIcon + " Text has to be " + maxlength + " characters or less";
		}
				
		if (!$(".control input",thisControl).val()) {
			$(".control input",thisControl).addClass("validate error").next('.errorLabel').html(errorMsg).show();
			return false;
		}
		else if ($(".control input",thisControl).val().length < minlength) {
			$(".control input",thisControl).addClass("validate error").next('.errorLabel').html(errorMsgMinlength).show();
			return false;
		}
		else if ($(".control input",thisControl).val().length > maxlength) {
			$(".control input",thisControl).addClass("validate error").next('.errorLabel').html(errorMsgMaxlength).show();
			return false;
		}
        
		buttonSelected($(this));
        var postback = '';
        var display = [];
		postback = $(".control input",thisControl).val();
		display.push($(".control input",thisControl).val());
		var _targetId = $(this).data('target');
		var _postbackType = $(this).data('postbacktype');

		sendMessage({ postback: postback, display: display, language: language, target: _targetId, postbackType: _postbackType });

        return false;
    });
	$(document).on('click', '.click-call-button', function(e) {
		e.preventDefault();

		// hide menu
		$('.offcanvas-wrapper').hide();
		resetSelectedButton();

		// if the click to call has become unavailable since the page loaded, disable and show message
		if (!currentTimeInRange(clickToCallUnavailableAfter, clickToCallTimezone)) {
			$('.click-call-form').hide();
			$('.click-call-unavailable').show();
		}

		// show click to call overlay
		$('.click-call-form-wrapper').show();
	});

	/***********************************************************/
	/***  Control Buttons - buttons with postback values    ****/
	/***********************************************************/

	$(document).on("click", ".control-buttons .btn", function(el) {
		if($(this).hasClass('click-call-button')) return false;
		var postback = ($(this).data('postback'));
		var display = ($(this).data('display'));
		var _targetId = ($(this).data('target'));
		var _postbackId = ($(this).data('postbackid'));
        var _postbackType = ($(this).data('postbacktype'));
		var _litigation = ($(this).data('litigation'));
        var _postbackTag = ($(this).data('postbacktag'));

		if (postback === 'displayMenu') {
			buttonSelected($(this));
			$('.offcanvas-wrapper').show();
		}
		else {
			//Open URLs in new window
			if (!$.isNumeric(postback) && postback.match("^http")) {
				window.open(postback, '_blank');
			}
			else {
				buttonSelected($(this));
				sendMessage({ postback: postback, display: [ display ], language: language, target: _targetId, postbackId: _postbackId, postbackType: _postbackType, postbackTag: _postbackTag, litigation: _litigation });
			}
		}
	 	return false;
	});

	/*******************************************************************/
	/***  County Selector Controller for when a state is clicked    ****/
	/*******************************************************************/
	$(document).on('change', '.stateCounty', function() {
        state = $(this).val();
		htmlJson = getCountyByState("--select county--", state);
		$(".county").children().remove().end();
		$('.county').prop("disabled", false);
		$('.county').append(htmlJson.htmlText[0]);
	});

	/* Code to get what options list should be displayed based on the answer to the state question */
	$(document).on('change', '.stateOptionsSelect', function() {
        state = $(this).val();
		optionsJson = $("#stateSelectOptionsJson").data("json");
		optionsTitle = $("#stateSelectOptionsTitle").data("text");
		if(state === ""){
			//no state return the null option
			var html = "<option style='color: red;' value=''>--select option--</option>";
		}
		else{
			var optionList = optionsJson[state];
			var html = "<option style='color: red;' value=''>" + optionsTitle + "</option>";
			if(typeof(optionList) === 'undefined'){
				optionList = optionsJson['default'];
			}
			$.each(optionList, function(index, value){
				html += "<option value='" + value.postback + "' data-display='" + value.display + "'>" + value.text + "</option>";
			});
		}

		var htmlJson = { htmlText: [html]};
		$(".optionSelect").children().remove().end();
		$('.optionSelect').prop("disabled", false);
		$('.optionSelect').append(htmlJson.htmlText[0]);
	});

	$(document).on('change','.control.stateOptionsControl select',function() {
		//we need to make sure that county and state are both full
		if ( ($(".optionSelect").val() !== '' && $(".optionSelect").val() !== undefined) && ($(".stateOptionsSelect").val() !== '' && $(".stateOptionsSelect").val() !== undefined)){

			$('button',$(this).closest('.control.stateOptionsControl')).removeAttr('disabled');
			//$('.modern .select .select-btnWrapper').show("slide", { direction: "down" }, 200);
		}
		else {
			$('button',$(this).closest('.control.stateOptionsControl')).attr('disabled',true);
			//$('.modern .select .select-btnWrapper').hide("slide", { direction: "down" }, 200);
		}
		
    });

	$('.controls').on("click",".stateOptionsControl button",function(e) {
		buttonSelected($(this));

		var thisControl = $(this).closest('form');
        
        var postback = '';
        var display = [];
		//state doesn't get picked up anyways so just exclude it for now in the postback
		postback = $(".optionSelect").val(); 
		
		if($(".optionSelect option:selected").data('display') === "undefined"){
			var optionPostback = postback;
		}
		else{
			var optionPostback = $(".optionSelect option:selected").data('display');
		}
		display.push($(".stateOptionsSelect option:selected").data('display'));
		display.push(optionPostback);

		sendMessage({ postback: postback, display: display, language: language });

        return false;
    });

	
	/* Code to get what options list should be displayed based on the answer to the state question */
	$(document).on('change', '.keyDualSelectOptions', function() {
        keyValue = $(this).val();
		optionsJson = $("#dualSelectOptionsJSON").data("json");
		optionsTitle = $("#dualSelectOptionsTitle").data("text");
		if(keyValue === ""){
			//no state return the null option
			var html = "<option style='color: red;' value=''>--select option--</option>";
		}
		else{
			var optionList = optionsJson[keyValue];
			var html = "<option style='color: red;' value=''>" + optionsTitle + "</option>";
			if(typeof(optionList) === 'undefined'){
				optionList = optionsJson['default'];
			}
			$.each(optionList, function(index, value){
				html += "<option value='" + value.postback + "' data-display='" + value.display + "'>" + value.text + "</option>";
			});
		}

		var htmlJson = { htmlText: [html]};
		$(".optionsDualSelectOptions").children().remove().end();
		$('.optionsDualSelectOptions').prop("disabled", false);
		$('.optionsDualSelectOptions').append(htmlJson.htmlText[0]);
	});

	$(document).on('change','.control.dualSelectControl select',function() {
		//we need to make sure that county and state are both full
		if ( ($(".optionsDualSelectOptions").val() !== '' && $(".optionsDualSelectOptions").val() !== undefined) && ($(".keyDualSelectOptions").val() !== '' && $(".keyDualSelectOptions").val() !== undefined)){

			$('button',$(this).closest('.control.dualSelectControl')).removeAttr('disabled');
			//$('.modern .select .select-btnWrapper').show("slide", { direction: "down" }, 200);
		}
		else {
			$('button',$(this).closest('.control.dualSelectControl')).attr('disabled',true);
			//$('.modern .select .select-btnWrapper').hide("slide", { direction: "down" }, 200);
		}
		
    });

	$('.controls').on("click",".dualSelectControl button",function(e) {
		buttonSelected($(this));

		var thisControl = $(this).closest('form');
        
        var postback = '';
        var display = [];
		//state doesn't get picked up anyways so just exclude it for now in the postback
		postback = $(".optionsDualSelectOptions").val(); 
		if($(".optionsDualSelectOptions option:selected").data('display') === "undefined"){
			var optionPostback = postback;
		}
		else{
			var optionPostback = $(".optionsDualSelectOptions option:selected").data('display');
		}
		display.push($(".keyDualSelectOptions option:selected").data('display'));
		display.push(optionPostback);

		sendMessage({ postback: postback, display: display, language: language });

        return false;
    });

	/*********************************************************/
    /************  Send to Node Server Actions ***************/
    /*********************************************************/

	function sendMessage(msg) {
		messenger.send(msg);
		//console.log(msg);
	}

	function prepareNextMessage(msg) {
		if (!msg.backButton) {
			$(".step-container .step-active").after('<div class="step step-next"><div class="message"></div></div>');
			$(".controls .step-active").after('<div class="step step-next"><form></form></div>');
		}

	}

	/******************************************************************/
    /***** Message Complete / ALL Responses Sent **********************/
    /******************************************************************/

	var _state = [];

	function messageComplete(jsonResponse) {

		console.log(jsonResponse);

		var currentState = jsonResponse.state;
		_state.push(currentState);
		
		if (theme == 'modern' && $('.step-active').length) {
			animateModernOut([animateModernIn, toggleComposer, messageCompleteCleanup, resetSelectedButton]);
		}
		else if (theme == 'modern' && $('.step-prev').length) 
			animateModernIn([toggleComposer, messageCompleteCleanup, resetSelectedButton]);
		else {
			resetSelectedButton();
			$(".step-active").addClass("step-prev").removeClass("step-active");
			$(".step-next").addClass("step-active").removeClass("step-next");
			toggleComposer();
			messageCompleteCleanup();
		}

		
		function messageCompleteCleanup() {
			//Start of flows, cleanup
			var intent = (jsonResponse.intent) ? jsonResponse.intent.toLowerCase() : '';
			if (intent.search("welcome") != -1 || intent.search("trigger") != -1 || intent.search("restart") != -1)
				$(".step-prev").remove();

			toggleBackButton(intent);

			progress('forward',jsonResponse.intent);
			
			if (theme == 'modern')
				parent.postMessage("widget_scroll_top",'*');
		}
	};

	/******************************************************************/
    /************  RESPONSE HANDLER ***********************************/
    /******************************************************************/

	var contactCaptured = false;
	var intent = '';

	function handleResponse(jsonResponse) {

		if ($('body').hasClass('modern'))
			handleModernResponse(jsonResponse);
		else 
			handleClassicResponse(jsonResponse);


		var statusId = (jsonResponse.statusId !== undefined) ? jsonResponse.statusId : 0;
		var caseCardEvents = (jsonResponse.caseCardEvents !== undefined) ? jsonResponse.caseCardEvents : false;
    	//push analytics event
    	if (jsonResponse.intent.indexOf('contact get') !== -1 && statusId !== 0 && !contactCaptured) {
        	contactCaptured = true;
			if (statusId == 10) {
        		parent.postMessage("chat_qualified_contact_captured",'*');
		 		//console.log("postMessage: chat_qualified_contact_captured");

				// Remove this once chat_qualified_contact_captured is being used by everyone
        		parent.postMessage("chat_contact_captured",'*');
			}
			else {
        		parent.postMessage("chat_contact_captured",'*');
		 		//console.log("postMessage: chat_contact_captured");
			}
    	}
		else if (caseCardEvents && statusId !== 0 && !contactCaptured) {
        	contactCaptured = true;
			if (statusId == 10) {
        		parent.postMessage("chat_qualified_contact_captured",'*');
		 		//console.log("postMessage: chat_qualified_contact_captured");

				// Remove this once chat_qualified_contact_captured is being used by everyone
        		parent.postMessage("chat_contact_captured",'*');
			}
			else {
        		parent.postMessage("chat_contact_captured",'*');
		 		//console.log("postMessage: chat_contact_captured");
			}
    	}
		else if (statusId !== 0) {
			if (statusId == 10) {
        		parent.postMessage("chat_qualified_pre_eval",'*');
		 		//console.log("postMessage: chat_qualified_pre_eval");
			}
			else {
        		parent.postMessage("chat_pre_eval",'*');
		 		//console.log("postMessage: chat_pre_eval");
			}
		}

		// send caseId and widgetUrl to embed so info can be inserted into the database
        var caseId = (jsonResponse.caseId !== undefined) ? jsonResponse.caseId : null;
		var widgetUrl = (jsonResponse.widgetUrl !== undefined) ? jsonResponse.widgetUrl : null;
		if (caseId !== null) {
			 parent.postMessage('caseId: ' + caseId + ',widgetUrl: ' + widgetUrl,'*');
			 caseIdGlobal=caseId;
		}
	};

	/*********************************************************/
    /************ CLICK TO CALL ******************************/
    /*********************************************************/
	
	if (clickToCall) {
		$(".click-call-trigger").click(function(e) {
			e.preventDefault();

			// hide menu
			$('.offcanvas-wrapper').hide();
			resetSelectedButton();

			// if the click to call has become unavailable since the page loaded, disable and show message
			if (!currentTimeInRange(clickToCallUnavailableAfter, clickToCallTimezone)) {
				$('.click-call-form').hide();
				$('.click-call-unavailable').show();
			}

			// show click to call overlay
			$('.click-call-form-wrapper').show();
		});

		$('#click-call-cancel').click(function(e) {
			e.preventDefault();
			
			// hide click to call overlay
			$('.click-call-form-wrapper').hide();

			// reset form
			$('.btnText', '#click-call-submit').html("Receive Call Now")
			//$('#click-call-cancel').html("Cancel");
			$('input', '.contactForm').val('');
			if ($('.click-call-consent').hasClass('checked')) {
				$('.click-call-consent').removeClass('checked')
				$('img', '.click-call-consent').attr("src", "./lib/fontawesome/svgs/regular/square.svg");
				$('img', '.click-call-consent').css("filter", "invert(0%) sepia(92%) saturate(0%) hue-rotate(337deg) brightness(92%) contrast(107%)");
				$('#click-call-submit').attr('disabled', true);
			}
		})
		
		$('.click-call-controls').on('click','.click-call-consent',function(e) {
			e.preventDefault();

			//need to change the filter for the colors on the images as we switch them over
			$(this).toggleClass('checked');
	
			var thisControl = $(this).closest('.control');
			var thisIcon = $('img',this);
	
			if ($(this).hasClass('checked')) {
				thisIcon.attr("src", "./lib/fontawesome/svgs/solid/check-square.svg");
				thisIcon.css("filter", "invert(35%) sepia(40%) saturate(2574%) hue-rotate(203deg) brightness(104%) contrast(93%)");
				$('#click-call-submit').attr('disabled', false);
			}
			else {
				thisIcon.attr("src", "./lib/fontawesome/svgs/regular/square.svg");
				thisIcon.css("filter", "invert(0%) sepia(92%) saturate(0%) hue-rotate(337deg) brightness(92%) contrast(107%)");
				$('#click-call-submit').attr('disabled', true);
			}
		});

		$('#click-call-submit').click(function(e) {
			var thisForm = $(".click-call-form > form");
			var phoneField = $(".contactPhone", thisForm);
			var submitButton = this;
			var cancelButton = $('#click-call-cancel')
			var warningIcon = "<span><img src='./lib/fontawesome/svgs/solid/exclamation-triangle.svg' style='filter: invert(15%) sepia(100%) saturate(7499%) hue-rotate(1deg) brightness(106%) contrast(112%);width:14px;height:13px'></span></i>";
			
			var formValid = true;
			var errorMsg=warningIcon + " Required";
			var phoneErrorMsg=warningIcon + (($(".contactPhone",thisForm).val()) ? " Valid 10 digit phone number required" : " Required");

			// if the click to call has become unavailable since the page loaded, disable and show message
			if (!currentTimeInRange(clickToCallUnavailableAfter, clickToCallTimezone)) {
				$('.click-call-form').hide();
				$('.click-call-unavailable').show();
				return;
			}

			var singleFields = [];
			if ($(".contactFname",thisForm).length) singleFields.push($(".contactFname",thisForm));
			if ($(".contactLname",thisForm).length) singleFields.push($(".contactLname",thisForm));
			
			for (var i=0;i<singleFields.length;i++) {		
				var curElem = singleFields[i];

				if (!curElem.val()) {
					curElem.addClass("validate error").next('.errorLabel').html(errorMsg).show();
					formValid = false;
				}
				else {
					curElem.removeClass("error").next('.errorLabel').hide();
				}
			}

			var validPhoneFormat = isValidPhoneNumberFormat($(".contactPhone",thisForm).val());

			if (!validPhoneFormat) { //phone invalid
				$(".contactPhone",thisForm).addClass("validate error").next('.errorLabel').html(phoneErrorMsg).show();
				formValid = false;
			}
			else { // phone validation passes
				$(".contactPhone",thisForm).removeClass("error").next('.errorLabel').hide();
			}

			if (!formValid) return;
			$(submitButton).prop("disabled", true);

			$.when(
				phoneServiceRequest(phoneField.val())
			)
			.then(function(phoneResponse) {
				phoneObj = phoneResponse.length ?  phoneResponse[0] : phoneResponse;
				if (!phoneObj.valid) {
					phoneMsg = warningIcon + "Please enter a valid phone number";
					phoneField.addClass("validate error").next('.errorLabel').html(phoneMsg).show();
					$(submitButton).prop("disabled", false);
				}
				else {
					_CALL_TRIGGER_URL=(_URL) ? _URL + "/app/embed/twilioStartCallAjax.php" : null;
					$.ajax({
						"url": _CALL_TRIGGER_URL,
						"data": {
							hash: hash, 
							client_phone: phoneField.val(), 
							fname: $(".contactFname",thisForm).val(), 
							lname: $(".contactLname",thisForm).val(),
							lawyer_phone: clickToCallPhone,
							case_id: caseIdGlobal,
						},
						"dataType": 'json',
						"type": "POST",
						"timeout": 3000,
						"success": function(data) {
							if (data.code == 1) {
								$('.btnText', submitButton).html("Calling now, please wait");
								setTimeout(function(){cancelButton.click()}, 1000)
								//$(cancelButton).html("Close");
							}
							else {
								phoneField.addClass("validate error").next('.errorLabel').html(warningIcon + "An error occurred, please try again.").show();
								$(submitButton).prop("disabled", false);
							}
						},
						"error" : function(xhr, status, error) {
							phoneField.addClass("validate error").next('.errorLabel').html(warningIcon + "An error occurred, please try again.").show();
							$(submitButton).prop("disabled", false);
						}
					});
				}
			})
			.fail( function( reason ) {
				phoneField.addClass("validate error").next('.errorLabel').html(warningIcon + "An error occurred, please try again.").show();
				$(submitButton).prop("disabled", false);
			})
		})
		
		if (clickToCallTrigger) {
			clickToCallTrigger = clickToCallTrigger.split('|');
			if (clickToCallTrigger.includes('menu')) 
				$('.click-call-trigger.trigger-menu').show();
			if (clickToCallTrigger.includes('header'))
				$('.click-call-trigger.trigger-header').data('enabled', 'true')
		}
	}

	//hard coded customizations for KMW, they want these buttons hidden
	if(hash == 'c7d3223e1e65269866d350fe7829690b'){
		$('.visitor-btn').hide();
		$('.existing-client-btn').hide();
		$('.trigger-menu').css('color', '#3776f6!important');
		$('.click-to-call-holder-custom').html("<span style='color:#3776f6!important;font-weight:400;font-size:1rem;line-height:1.5'>Request A Call</span>");
	}
	/*********************************************************/
    /************ BACK BUTTON ********************************/
    /*********************************************************/

	$(".btn-previous").click(function(e) {
		e.preventDefault();
		
		buttonSelected($(this));

		if (language == 'en-US') {
            var _display = ['Previous Step'];
        }
        else if (language == 'es-ES') {
            var _display = ['Paso anterior'];
        }
        else if (language == 'fr-FR') {
            var _display = ['Étape précédente'];
        }

		//Remove character counter	
		$(".char-counter, .modern-char-counter").addClass("d-none");

		var msg = { postback: "Previous Step", display: _display, backButton: "back", language: language };

		sendMessage(msg);

		return false;
	});

	function handleBackPress(jsonResponse) {

		_state.pop();

		var intent = (jsonResponse.intent) ? jsonResponse.intent.toLowerCase() : '';
		var html = (jsonResponse.html) ? jsonResponse.html : '';

		if ($('body').hasClass('modern')) {
			var _intent = intent;
			handleModernBackPress( function() {
				toggleBackButton(_intent);
				progress('backward');
			});
		}
		else {
			handleClassicBackPress(html)
			toggleBackButton(intent);
			progress('backward');
		}
	};

	function handleClassicBackPress(html) {

    	var prevMessage = $(".step-container .step-prev").last();
    	var prevForm = $(".controls .step-prev").last();
    
    	var activeMessage = $(".step-container .step-active");
    	var activeForm = $(".controls .step-active");
    	
    	var prevMessageCopy=$(prevMessage).clone().removeClass('step-prev').addClass('step-active');
    	
    	//Change previous reques to "Previous Step"
    	$(prevMessageCopy).find(".request").remove();
    	$(prevMessageCopy).find(".message").prepend(html);
    	
    	//Not removing the previous step but we dont want to go back to it either
    	prevMessage.removeClass('step-prev').addClass('step-null');
    	activeMessage.removeClass('step-active').addClass('step-null');
    	
    	$('.step-container').append(prevMessageCopy);
    	
    	$('.controls .step-active').remove();
    	$('.controls .step-prev').last().removeClass('step-prev').addClass('step-active');

		resetSelectedButton();	
    	toggleComposer();
	
		$('.messages').animate({
            scrollTop: $('.messages')[0].scrollHeight
        }, 500);

	}

	function handleModernBackPress(runAfterAnimation) {
		animateModernInReverse([animateModernOutReverse, runAfterAnimation, toggleComposer, resetSelectedButton]);
	}

	function toggleBackButton(intent) {
    	if ($(".step-prev").length > 0 && !$(".step-active .item.case-card").length && (intent.search('common.15.contact get - evaluate') == -1)) {
			$('body').addClass("previous-visible");
    	}
    	else {
			$('body').removeClass("previous-visible");
    	}
	}

	/******************************************************************/
    /************  CLASSIC FUNCTIONALITY ******************************/
    /******************************************************************/

	function handleClassicResponse(jsonResponse) {

    	html = jsonResponse.html;
    	intent = jsonResponse.intent;

    	//Create a dom node out of the response
    	var div = document.createElement('div');
    	div.innerHTML = html.trim();
    	var responseObj = div.firstChild;
	
    	//If Typing animation is happening time to remove it
    	$('.sender-action').parent('.response').remove();
	
    	//Get the Control from the response
    	var control = responseObj.getElementsByClassName("control")[0];
	
    	//Remove the control from the message
    	var message = responseObj;
    	$(message).find(".control").remove();
	
    	//Use default control if none specified
    	if (control === undefined) control = defaultComposer;
	
    	var txt = $(message).find('.response-text p').text();
	
    	if (txt.indexOf("!!form!!") >= 0)
        	return;
    	else if (txt.indexOf("!!conv!!") >= 0)
        	$(message).find('.response-text p').text(txt.replace(/!!conv!!/g,'').trim());
	
    	$('.step-container .step-next .message').append(message);
    	$('.controls .step-next form').html(control);
	
    	$('.messages').animate({
        	scrollTop: $('.messages')[0].scrollHeight
    	}, 500);
	}

	/******************************************************************/
    /************  MODERN FUNCTIONALITY ******************************/
    /******************************************************************/

	var thinking = '';

	function handleModernResponse(jsonResponse) {
	
    	html = jsonResponse.html;
    	intent = jsonResponse.intent;
	
    	//Create a dom node out of the response
    	var div = document.createElement('div');
    	div.innerHTML = html.trim();
    	var responseObj = div.firstChild;
	
    	//Am I Thinking
    	thinking = ($(responseObj).find('.sender-action').length !==0);
	
    	//Get the new Control from the response if any
    	var control = responseObj.getElementsByClassName("control")[0];
	
		var message = responseObj;
        $(message).find(".control").remove();

        //Use default control if none specified
        if (control === undefined) control = defaultComposer;
	
    	//New Response unless its thinking
    	if (!thinking) {
	
        	//Add new Control
			if (control === undefined) control = defaultComposer;
	
        	var txt = $(message).find('.response-text p').text();
	
        	if (txt.indexOf("!!conv!!") >= 0)
            	return;
        	else if (txt.indexOf("!!form!!") >= 0)
            	$(message).find('.response-text p').text(txt.replace(/!!form!!/g,'').trim());
	
			$(".step-container .step-next .message").append(message);
			$('.controls .step-next form').html(control);
	
    	}
    	else if ($(message).hasClass("response")) {
        	//Thinking
           	//$('.spinner').append('<i class="fal fa-spinner fa-spin fa-2x"></i>');
    	}
    	else {
        	//Requests - no print in modern
    	}
	}

	function getCountyByState(selectTitle, state){
		var countiesJson = { "states": {
			"Alabama":["Autauga County","Baldwin County","Barbour County","Bibb County","Blount County","Bullock County","Butler County","Calhoun County","Chambers County","Cherokee County","Chilton County","Choctaw County","Clarke County","Clay County","Cleburne County","Coffee County","Colbert County","Conecuh County","Coosa County","Covington County","Crenshaw County","Cullman County","Dale County","Dallas County","DeKalb County","Elmore County","Escambia County","Etowah County","Fayette County","Franklin County","Geneva County","Greene County","Hale County","Henry County","Houston County","Jackson County","Jefferson County","Lamar County","Lauderdale County","Lawrence County","Lee County","Limestone County","Lowndes County","Macon County","Madison County","Marengo County","Marion County","Marshall County","Mobile County","Monroe County","Montgomery County","Morgan County","Perry County","Pickens County","Pike County","Randolph County","Russell County","St. Clair County","Shelby County","Sumter County","Talladega County","Tallapoosa County","Tuscaloosa County","Walker County","Washington County","Wilcox County","Winston County"],
   			"Alaska":["Aleutians East Borough","Aleutians West Census Area","Anchorage","Bethel Census Area","Bristol Bay Borough","Chugach Mountains","Copper River Census Area","Denali Borough","Dillingham Census Area","Fairbanks North Star Borough","Haines Borough","Hoonah–Angoon Census Area","Juneau","Kenai Peninsula","Ketchikan Gateway Borough","Kodiak","Kusilvak Census Area","Lake and Peninsula Borough","Matanuska-Susitna Borough","Nome Census Area","North Slope Borough","Northwest Arctic","Petersburg Borough","Prince of Wales – Hyder Census Area","Sitka","Skagway","Southeast Fairbanks Census Area","Wrangell","Yakutat","Yukon–Koyukuk Census Area"],
			"Arizona":["Apache County","Cochise County","Coconino County","Gila County","Graham County","Greenlee County","La Paz County","Maricopa County","Mohave County","Navajo County","Pima County","Pinal County","Santa Cruz County","Yavapai County","Yuma County"],
			"Arkansas":["Arkansas County","Ashley County","Baxter County","Benton County","Boone County","Bradley County","Calhoun County","Carroll County","Chicot County","Clark County","Clay County","Cleburne County","Cleveland County","Columbia County","Conway County","Craighead County","Crawford County","Crittenden County","Cross County","Dallas County","Desha County","Drew County","Faulkner County","Franklin County","Fulton County","Garland County","Grant County","Greene County","Hempstead County","Hot Spring County","Howard County","Independence County","Izard County","Jackson County","Jefferson County","Johnson County","Lafayette County","Lawrence County","Lee County","Lincoln County","Little River County","Logan County","Lonoke County","Madison County","Marion County","Miller County","Mississippi County","Monroe County","Montgomery County","Nevada County","Newton County","Ouachita County","Perry County","Phillips County","Pike County","Poinsett County","Polk County","Pope County","Prairie County","Pulaski County","Randolph County","St. Francis County","Saline County","Scott County","Searcy County","Sebastian County","Sevier County","Sharp County","Stone County","Union County","Van Buren County","Washington County","White County","Woodruff County","Yell County"],
			"California":["Alameda County","Alpine County","Amador County","Butte County","Calaveras County","Colusa County","Contra Costa County","Del Norte County","El Dorado County","Fresno County","Glenn County","Humboldt County","Imperial County","Inyo County","Kern County","Kings County","Lake County","Lassen County","Los Angeles County","Madera County","Marin County","Mariposa County","Mendocino County","Merced County","Modoc County","Mono County","Monterey County","Napa County","Nevada County","Orange County","Placer County","Plumas County","Riverside County","Sacramento County","San Benito County","San Bernardino County","San Diego County","San Francisco County","San Joaquin County","San Luis Obispo County","San Mateo County","Santa Barbara County","Santa Clara County","Santa Cruz County","Shasta County","Sierra County","Siskiyou County","Solano County","Sonoma County","Stanislaus County","Sutter County","Tehama County","Trinity County","Tulare County","Tuolumne County","Ventura County","Yolo County","Yuba County"],
			"Colorado":["Adams County","Alamosa County","Arapahoe County","Archuleta County","Baca County","Bent County","Boulder County","Broomfield County","Chaffee County","Cheyenne County","Clear Creek County","Conejos County","Costilla County","Crowley County","Custer County","Delta County","Denver County","Dolores County","Douglas County","Eagle County","Elbert County","El Paso County","Fremont County","Garfield County","Gilpin County","Grand County","Gunnison County","Hinsdale County","Huerfano County","Jackson County","Jefferson County","Kiowa County","Kit Carson County","Lake County","La Plata County","Larimer County","Las Animas County","Lincoln County","Logan County","Mesa County","Mineral County","Moffat County","Montezuma County","Montrose County","Morgan County","Otero County","Ouray County","Park County","Phillips County","Pitkin County","Prowers County","Pueblo County","Rio Blanco County","Rio Grande County","Routt County","Saguache County","San Juan County","San Miguel County","Sedgwick County","Summit County","Teller County","Washington County","Weld County","Yuma County"],
			"Connecticut":["Fairfield County","Hartford County","Litchfield County","Middlesex County","New Haven County","New London County","Tolland County","Windham County"],
			"Delaware":["Kent County","New Castle County","Sussex County"],
			"District of Columbia":["District of Columbia County"],
			"Florida":["Alachua County","Baker County","Bay County","Bradford County","Brevard County","Broward County","Calhoun County","Charlotte County","Citrus County","Clay County","Collier County","Columbia County","DeSoto County","Dixie County","Duval County","Escambia County","Flagler County","Franklin County","Gadsden County","Gilchrist County","Glades County","Gulf County","Hamilton County","Hardee County","Hendry County","Hernando County","Highlands County","Hillsborough County","Holmes County","Indian River County","Jackson County","Jefferson County","Lafayette County","Lake County","Lee County","Leon County","Levy County","Liberty County","Madison County","Manatee County","Marion County","Martin County","Miami-Dade County","Monroe County","Nassau County","Okaloosa County","Okeechobee County","Orange County","Osceola County","Palm Beach County","Pasco County","Pinellas County","Polk County","Putnam County","St. Johns County","St. Lucie County","Santa Rosa County","Sarasota County","Seminole County","Sumter County","Suwannee County","Taylor County","Union County","Volusia County","Wakulla County","Walton County","Washington County"],
			"Georgia":["Appling County","Atkinson County","Bacon County","Baker County","Baldwin County","Banks County","Barrow County","Bartow County","Ben Hill County","Berrien County","Bibb County","Bleckley County","Brantley County","Brooks County","Bryan County","Bulloch County","Burke County","Butts County","Calhoun County","Camden County","Candler County","Carroll County","Catoosa County","Charlton County","Chatham County","Chattahoochee County","Chattooga County","Cherokee County","Clarke County","Clay County","Clayton County","Clinch County","Cobb County","Coffee County","Colquitt County","Columbia County","Cook County","Coweta County","Crawford County","Crisp County","Dade County","Dawson County","Decatur County","DeKalb County","Dodge County","Dooly County","Dougherty County","Douglas County","Early County","Echols County","Effingham County","Elbert County","Emanuel County","Evans County","Fannin County","Fayette County","Floyd County","Forsyth County","Franklin County","Fulton County","Gilmer County","Glascock County","Glynn County","Gordon County","Grady County","Greene County","Gwinnett County","Habersham County","Hall County","Hancock County","Haralson County","Harris County","Hart County","Heard County","Henry County","Houston County","Irwin County","Jackson County","Jasper County","Jeff Davis County","Jefferson County","Jenkins County","Johnson County","Jones County","Lamar County","Lanier County","Laurens County","Lee County","Liberty County","Lincoln County","Long County","Lowndes County","Lumpkin County","McDuffie County","McIntosh County","Macon County","Madison County","Marion County","Meriwether County","Miller County","Mitchell County","Monroe County","Montgomery County","Morgan County","Murray County","Muscogee County","Newton County","Oconee County","Oglethorpe County","Paulding County","Peach County","Pickens County","Pierce County","Pike County","Polk County","Pulaski County","Putnam County","Quitman County","Rabun County","Randolph County","Richmond County","Rockdale County","Schley County","Screven County","Seminole County","Spalding County","Stephens County","Stewart County","Sumter County","Talbot County","Taliaferro County","Tattnall County","Taylor County","Telfair County","Terrell County","Thomas County","Tift County","Toombs County","Towns County","Treutlen County","Troup County","Turner County","Twiggs County","Union County","Upson County","Walker County","Walton County","Ware County","Warren County","Washington County","Wayne County","Webster County","Wheeler County","White County","Whitfield County","Wilcox County","Wilkes County","Wilkinson County","Worth County"],
			"Hawaii":["Hawaii County","Honolulu","Kalawao County","Kauai County","Maui County"],
			"Idaho":["Ada County","Adams County","Bannock County","Bear Lake County","Benewah County","Bingham County","Blaine County","Boise County","Bonner County","Bonneville County","Boundary County","Butte County","Camas County","Canyon County","Caribou County","Cassia County","Clark County","Clearwater County","Custer County","Elmore County","Franklin County","Fremont County","Gem County","Gooding County","Idaho County","Jefferson County","Jerome County","Kootenai County","Latah County","Lemhi County","Lewis County","Lincoln County","Madison County","Minidoka County","Nez Perce County","Oneida County","Owyhee County","Payette County","Power County","Shoshone County","Teton County","Twin Falls County","Valley County","Washington County"],
			"Illinois":["Adams County","Alexander County","Bond County","Boone County","Brown County","Bureau County","Calhoun County","Carroll County","Cass County","Champaign County","Christian County","Clark County","Clay County","Clinton County","Coles County","Cook County","Crawford County","Cumberland County","DeKalb County","DeWitt County","Douglas County","DuPage County","Edgar County","Edwards County","Effingham County","Fayette County","Ford County","Franklin County","Fulton County","Gallatin County","Greene County","Grundy County","Hamilton County","Hancock County","Hardin County","Henderson County","Henry County","Iroquois County","Jackson County","Jasper County","Jefferson County","Jersey County","Jo Daviess County","Johnson County","Kane County","Kankakee County","Kendall County","Knox County","Lake County","LaSalle County","Lawrence County","Lee County","Livingston County","Logan County","McDonough County","McHenry County","McLean County","Macon County","Macoupin County","Madison County","Marion County","Marshall County","Mason County","Massac County","Menard County","Mercer County","Monroe County","Montgomery County","Morgan County","Moultrie County","Ogle County","Peoria County","Perry County","Piatt County","Pike County","Pope County","Pulaski County","Putnam County","Randolph County","Richland County","Rock Island County","St. Clair County","Saline County","Sangamon County","Schuyler County","Scott County","Shelby County","Stark County","Stephenson County","Tazewell County","Union County","Vermilion County","Wabash County","Warren County","Washington County","Wayne County","White County","Whiteside County","Will County","Williamson County","Winnebago County","Woodford County"],
			"Indiana":["Adams County","Allen County","Bartholomew County","Benton County","Blackford County","Boone County","Brown County","Carroll County","Cass County","Clark County","Clay County","Clinton County","Crawford County","Daviess County","Dearborn County","Decatur County","DeKalb County","Delaware County","Dubois County","Elkhart County","Fayette County","Floyd County","Fountain County","Franklin County","Fulton County","Gibson County","Grant County","Greene County","Hamilton County","Hancock County","Harrison County","Hendricks County","Henry County","Howard County","Huntington County","Jackson County","Jasper County","Jay County","Jefferson County","Jennings County","Johnson County","Knox County","Kosciusko County","LaGrange County","Lake County","LaPorte County","Lawrence County","Madison County","Marion County","Marshall County","Martin County","Miami County","Monroe County","Montgomery County","Morgan County","Newton County","Noble County","Ohio County","Orange County","Owen County","Parke County","Perry County","Pike County","Porter County","Posey County","Pulaski County","Putnam County","Randolph County","Ripley County","Rush County","St. Joseph County","Scott County","Shelby County","Spencer County","Starke County","Steuben County","Sullivan County","Switzerland County","Tippecanoe County","Tipton County","Union County","Vanderburgh County","Vermillion County","Vigo County","Wabash County","Warren County","Warrick County","Washington County","Wayne County","Wells County","White County","Whitley County"],
			"Iowa":["Adair County","Adams County","Allamakee County","Appanoose County","Audubon County","Benton County","Black Hawk County","Boone County","Bremer County","Buchanan County","Buena Vista County","Butler County","Calhoun County","Carroll County","Cass County","Cedar County","Cerro Gordo County","Cherokee County","Chickasaw County","Clarke County","Clay County","Clayton County","Clinton County","Crawford County","Dallas County","Davis County","Decatur County","Delaware County","Des Moines County","Dickinson County","Dubuque County","Emmet County","Fayette County","Floyd County","Franklin County","Fremont County","Greene County","Grundy County","Guthrie County","Hamilton County","Hancock County","Hardin County","Harrison County","Henry County","Howard County","Humboldt County","Ida County","Iowa County","Jackson County","Jasper County","Jefferson County","Johnson County","Jones County","Keokuk County","Kossuth County","Lee County","Linn County","Louisa County","Lucas County","Lyon County","Madison County","Mahaska County","Marion County","Marshall County","Mills County","Mitchell County","Monona County","Monroe County","Montgomery County","Muscatine County","OBrien County","Osceola County","Page County","Palo Alto County","Plymouth County","Pocahontas County","Polk County","Pottawattamie County","Poweshiek County","Ringgold County","Sac County","Scott County","Shelby County","Sioux County","Story County","Tama County","Taylor County","Union County","Van Buren County","Wapello County","Warren County","Washington County","Wayne County","Webster County","Winnebago County","Winneshiek County","Woodbury County","Worth County","Wright County"],
			"Kansas":["Allen County","Anderson County","Atchison County","Barber County","Barton County","Bourbon County","Brown County","Butler County","Chase County","Chautauqua County","Cherokee County","Cheyenne County","Clark County","Clay County","Cloud County","Coffey County","Comanche County","Cowley County","Crawford County","Decatur County","Dickinson County","Doniphan County","Douglas County","Edwards County","Elk County","Ellis County","Ellsworth County","Finney County","Ford County","Franklin County","Geary County","Gove County","Graham County","Grant County","Gray County","Greeley County","Greenwood County","Hamilton County","Harper County","Harvey County","Haskell County","Hodgeman County","Jackson County","Jefferson County","Jewell County","Johnson County","Kearny County","Kingman County","Kiowa County","Labette County","Lane County","Leavenworth County","Lincoln County","Linn County","Logan County","Lyon County","McPherson County","Marion County","Marshall County","Meade County","Miami County","Mitchell County","Montgomery County","Morris County","Morton County","Nemaha County","Neosho County","Ness County","Norton County","Osage County","Osborne County","Ottawa County","Pawnee County","Phillips County","Pottawatomie County","Pratt County","Rawlins County","Reno County","Republic County","Rice County","Riley County","Rooks County","Rush County","Russell County","Saline County","Scott County","Sedgwick County","Seward County","Shawnee County","Sheridan County","Sherman County","Smith County","Stafford County","Stanton County","Stevens County","Sumner County","Thomas County","Trego County","Wabaunsee County","Wallace County","Washington County","Wichita County","Wilson County","Woodson County","Wyandotte County"],
			"Kentucky":["Adair County","Allen County","Anderson County","Ballard County","Barren County","Bath County","Bell County","Boone County","Bourbon County","Boyd County","Boyle County","Bracken County","Breathitt County","Breckinridge County","Bullitt County","Butler County","Caldwell County","Calloway County","Campbell County","Carlisle County","Carroll County","Carter County","Casey County","Christian County","Clark County","Clay County","Clinton County","Crittenden County","Cumberland County","Daviess County","Edmonson County","Elliott County","Estill County","Fayette County","Fleming County","Floyd County","Franklin County","Fulton County","Gallatin County","Garrard County","Grant County","Graves County","Grayson County","Green County","Greenup County","Hancock County","Hardin County","Harlan County","Harrison County","Hart County","Henderson County","Henry County","Hickman County","Hopkins County","Jackson County","Jefferson County","Jessamine County","Johnson County","Kenton County","Knott County","Knox County","LaRue County","Laurel County","Lawrence County","Lee County","Leslie County","Letcher County","Lewis County","Lincoln County","Livingston County","Logan County","Lyon County","McCracken County","McCreary County","McLean County","Madison County","Magoffin County","Marion County","Marshall County","Martin County","Mason County","Meade County","Menifee County","Mercer County","Metcalfe County","Monroe County","Montgomery County","Morgan County","Muhlenberg County","Nelson County","Nicholas County","Ohio County","Oldham County","Owen County","Owsley County","Pendleton County","Perry County","Pike County","Powell County","Pulaski County","Robertson County","Rockcastle County","Rowan County","Russell County","Scott County","Shelby County","Simpson County","Spencer County","Taylor County","Todd County","Trigg County","Trimble County","Union County","Warren County","Washington County","Wayne County","Webster County","Whitley County","Wolfe County","Woodford County"],
			"Louisiana":["Acadia Parish","Allen Parish","Ascension Parish","Assumption Parish","Avoyelles Parish","Beauregard Parish","Bienville Parish","Bossier Parish","Caddo Parish","Calcasieu Parish","Caldwell Parish","Cameron Parish","Catahoula Parish","Claiborne Parish","Concordia Parish","De Soto Parish","East Baton Rouge Parish","East Carroll Parish","East Feliciana Parish","Evangeline Parish","Franklin Parish","Grant Parish","Iberia Parish","Iberville Parish","Jackson Parish","Jefferson Parish","Jefferson Davis Parish","Lafayette Parish","Lafourche Parish","LaSalle Parish","Lincoln Parish","Livingston Parish","Madison Parish","Morehouse Parish","Natchitoches Parish","New Orleans Parish","Ouachita Parish","Plaquemines Parish","Pointe Coupee Parish","Rapides Parish","Red River Parish","Richland Parish","Sabine Parish","St. Bernard Parish","St. Charles Parish","St. Helena Parish","St. James Parish","St. John the Baptist Parish","St. Landry Parish","St. Martin Parish","St. Mary Parish","St. Tammany Parish","Tangipahoa Parish","Tensas Parish","Terrebonne Parish","Union Parish","Vermilion Parish","Vernon Parish","Washington Parish","Webster Parish","West Baton Rouge Parish","West Carroll Parish","West Feliciana Parish","Winn Parish"],
			"Maine":["Androscoggin County","Aroostook County","Cumberland County","Franklin County","Hancock County","Kennebec County","Knox County","Lincoln County","Oxford County","Penobscot County","Piscataquis County","Sagadahoc County","Somerset County","Waldo County","Washington County","York County"],
			"Maryland":["Allegany County","Anne Arundel County","Baltimore County","Calvert County","Caroline County","Carroll County","Cecil County","Charles County","Dorchester County","Frederick County","Garrett County","Harford County","Howard County","Kent County","Montgomery County","Prince George\'s County","Queen Anne\'s County","St. Mary County","Somerset County","Talbot County","Washington County","Wicomico County","Worcester County","Baltimore City County"],
			"Massachusetts":["Barnstable County","Berkshire County","Bristol County","Dukes County","Essex County","Franklin County","Hampden County","Hampshire County","Middlesex County","Nantucket County","Norfolk County","Plymouth County","Suffolk County","Worcester County"],
			"Michigan":["Alcona County","Alger County","Allegan County","Alpena County","Antrim County","Arenac County","Baraga County","Barry County","Bay County","Benzie County","Berrien County","Branch County","Calhoun County","Cass County","Charlevoix County","Cheboygan County","Chippewa County","Clare County","Clinton County","Crawford County","Delta County","Dickinson County","Eaton County","Emmet County","Genesee County","Gladwin County","Gogebic County","Grand Traverse County","Gratiot County","Hillsdale County","Houghton County","Huron County","Ingham County","Ionia County","Iosco County","Iron County","Isabella County","Jackson County","Kalamazoo County","Kalkaska County","Kent County","Keweenaw County","Lake County","Lapeer County","Leelanau County","Lenawee County","Livingston County","Luce County","Mackinac County","Macomb County","Manistee County","Marquette County","Mason County","Mecosta County","Menominee County","Midland County","Missaukee County","Monroe County","Montcalm County","Montmorency County","Muskegon County","Newaygo County","Oakland County","Oceana County","Ogemaw County","Ontonagon County","Osceola County","Oscoda County","Otsego County","Ottawa County","Presque Isle County","Roscommon County","Saginaw County","St. Clair County","St. Joseph County","Sanilac County","Schoolcraft County","Shiawassee County","Tuscola County","Van Buren County","Washtenaw County","Wayne County","Wexford County"],
			"Minnesota":["Aitkin County","Anoka County","Becker County","Beltrami County","Benton County","Big Stone County","Blue Earth County","Brown County","Carlton County","Carver County","Cass County","Chippewa County","Chisago County","Clay County","Clearwater County","Cook County","Cottonwood County","Crow Wing County","Dakota County","Dodge County","Douglas County","Faribault County","Fillmore County","Freeborn County","Goodhue County","Grant County","Hennepin County","Houston County","Hubbard County","Isanti County","Itasca County","Jackson County","Kanabec County","Kandiyohi County","Kittson County","Koochiching County","Lac qui Parle County","Lake County","Lake of the Woods County","Le Sueur County","Lincoln County","Lyon County","McLeod County","Mahnomen County","Marshall County","Martin County","Meeker County","Mille Lacs County","Morrison County","Mower County","Murray County","Nicollet County","Nobles County","Norman County","Olmsted County","Otter Tail County","Pennington County","Pine County","Pipestone County","Polk County","Pope County","Ramsey County","Red Lake County","Redwood County","Renville County","Rice County","Rock County","Roseau County","St. Louis County","Scott County","Sherburne County","Sibley County","Stearns County","Steele County","Stevens County","Swift County","Todd County","Traverse County","Wabasha County","Wadena County","Waseca County","Washington County","Watonwan County","Wilkin County","Winona County","Wright County","Yellow Medicine County"],
			"Mississippi":["Adams County","Alcorn County","Amite County","Attala County","Benton County","Bolivar County","Calhoun County","Carroll County","Chickasaw County","Choctaw County","Claiborne County","Clarke County","Clay County","Coahoma County","Copiah County","Covington County","DeSoto County","Forrest County","Franklin County","George County","Greene County","Grenada County","Hancock County","Harrison County","Hinds County","Holmes County","Humphreys County","Issaquena County","Itawamba County","Jackson County","Jasper County","Jefferson County","Jefferson Davis County","Jones County","Kemper County","Lafayette County","Lamar County","Lauderdale County","Lawrence County","Leake County","Lee County","Leflore County","Lincoln County","Lowndes County","Madison County","Marion County","Marshall County","Monroe County","Montgomery County","Neshoba County","Newton County","Noxubee County","Oktibbeha County","Panola County","Pearl River County","Perry County","Pike County","Pontotoc County","Prentiss County","Quitman County","Rankin County","Scott County","Sharkey County","Simpson County","Smith County","Stone County","Sunflower County","Tallahatchie County","Tate County","Tippah County","Tishomingo County","Tunica County","Union County","Walthall County","Warren County","Washington County","Wayne County","Webster County","Wilkinson County","Winston County","Yalobusha County","Yazoo County"],
			"Missouri":["Adair County","Andrew County","Atchison County","Audrain County","Barry County","Barton County","Bates County","Benton County","Bollinger County","Boone County","Buchanan County","Butler County","Caldwell County","Callaway County","Camden County","Cape Girardeau County","Carroll County","Carter County","Cass County","Cedar County","Chariton County","Christian County","Clark County","Clay County","Clinton County","Cole County","Cooper County","Crawford County","Dade County","Dallas County","Daviess County","DeKalb County","Dent County","Douglas County","Dunklin County","Franklin County","Gasconade County","Gentry County","Greene County","Grundy County","Harrison County","Henry County","Hickory County","Holt County","Howard County","Howell County","Iron County","Jackson County","Jasper County","Jefferson County","Johnson County","Knox County","Laclede County","Lafayette County","Lawrence County","Lewis County","Lincoln County","Linn County","Livingston County","McDonald County","Macon County","Madison County","Maries County","Marion County","Mercer County","Miller County","Mississippi County","Moniteau County","Monroe County","Montgomery County","Morgan County","New Madrid County","Newton County","Nodaway County","Oregon County","Osage County","Ozark County","Pemiscot County","Perry County","Pettis County","Phelps County","Pike County","Platte County","Polk County","Pulaski County","Putnam County","Ralls County","Randolph County","Ray County","Reynolds County","Ripley County","St. Charles County","St. Clair County","Ste. Genevieve County","St. Francois County","St. Louis County","Saline County","Schuyler County","Scotland County","Scott County","Shannon County","Shelby County","Stoddard County","Stone County","Sullivan County","Taney County","Texas County","Vernon County","Warren County","Washington County","Wayne County","Webster County","Worth County","Wright County","St. Louis County"],
			"Montana":["Beaverhead County","Big Horn County","Blaine County","Broadwater County","Carbon County","Carter County","Cascade County","Chouteau County","Custer County","Daniels County","Dawson County","Deer Lodge County","Fallon County","Fergus County","Flathead County","Gallatin County","Garfield County","Glacier County","Golden Valley County","Granite County","Hill County","Jefferson County","Judith Basin County","Lake County","Lewis and Clark County","Liberty County","Lincoln County","McCone County","Madison County","Meagher County","Mineral County","Missoula County","Musselshell County","Park County","Petroleum County","Phillips County","Pondera County","Powder River County","Powell County","Prairie County","Ravalli County","Richland County","Roosevelt County","Rosebud County","Sanders County","Sheridan County","Silver Bow County","Stillwater County","Sweet Grass County","Teton County","Toole County","Treasure County","Valley County","Wheatland County","Wibaux County","Yellowstone County"],
			"Nebraska":["Adams County","Antelope County","Arthur County","Banner County","Blaine County","Boone County","Box Butte County","Boyd County","Brown County","Buffalo County","Burt County","Butler County","Cass County","Cedar County","Chase County","Cherry County","Cheyenne County","Clay County","Colfax County","Cuming County","Custer County","Dakota County","Dawes County","Dawson County","Deuel County","Dixon County","Dodge County","Douglas County","Dundy County","Fillmore County","Franklin County","Frontier County","Furnas County","Gage County","Garden County","Garfield County","Gosper County","Grant County","Greeley County","Hall County","Hamilton County","Harlan County","Hayes County","Hitchcock County","Holt County","Hooker County","Howard County","Jefferson County","Johnson County","Kearney County","Keith County","Keya Paha County","Kimball County","Knox County","Lancaster County","Lincoln County","Logan County","Loup County","McPherson County","Madison County","Merrick County","Morrill County","Nance County","Nemaha County","Nuckolls County","Otoe County","Pawnee County","Perkins County","Phelps County","Pierce County","Platte County","Polk County","Red Willow County","Richardson County","Rock County","Saline County","Sarpy County","Saunders County","Scotts Bluff County","Seward County","Sheridan County","Sherman County","Sioux County","Stanton County","Thayer County","Thomas County","Thurston County","Valley County","Washington County","Wayne County","Webster County","Wheeler County","York County"],
			"Nevada":["Churchill County","Clark County","Douglas County","Elko County","Esmeralda County","Eureka County","Humboldt County","Lander County","Lincoln County","Lyon County","Mineral County","Nye County","Pershing County","Storey County","Washoe County","White Pine County","Carson City County"],
			"New Hampshire":["Belknap County","Carroll County","Cheshire County","Coos County","Grafton County","Hillsborough County","Merrimack County","Rockingham County","Strafford County","Sullivan County"],
			"New Jersey":["Atlantic County","Bergen County","Burlington County","Camden County","Cape May County","Cumberland County","Essex County","Gloucester County","Hudson County","Hunterdon County","Mercer County","Middlesex County","Monmouth County","Morris County","Ocean County","Passaic County","Salem County","Somerset County","Sussex County","Union County","Warren County"],
			"New Mexico":["Bernalillo County","Catron County","Chaves County","Cibola County","Colfax County","Curry County","De Baca County","Doña Ana County","Eddy County","Grant County","Guadalupe County","Harding County","Hidalgo County","Lea County","Lincoln County","Los Alamos County","Luna County","McKinley County","Mora County","Otero County","Quay County","Rio Arriba County","Roosevelt County","Sandoval County","San Juan County","San Miguel County","Santa Fe County","Sierra County","Socorro County","Taos County","Torrance County","Union County","Valencia County"],
			"New York":["Albany County","Allegany County","Bronx County","Broome County","Cattaraugus County","Cayuga County","Chautauqua County","Chemung County","Chenango County","Clinton County","Columbia County","Cortland County","Delaware County","Dutchess County","Erie County","Essex County","Franklin County","Fulton County","Genesee County","Greene County","Hamilton County","Herkimer County","Jefferson County","Kings County","Lewis County","Livingston County","Madison County","Monroe County","Montgomery County","Nassau County","New York County","Niagara County","Oneida County","Onondaga County","Ontario County","Orange County","Orleans County","Oswego County","Otsego County","Putnam County","Queens County","Rensselaer County","Richmond County","Rockland County","St. Lawrence County","Saratoga County","Schenectady County","Schoharie County","Schuyler County","Seneca County","Steuben County","Suffolk County","Sullivan County","Tioga County","Tompkins County","Ulster County","Warren County","Washington County","Wayne County","Westchester County","Wyoming County","Yates County"],
			"North Carolina":["Alamance County","Alexander County","Alleghany County","Anson County","Ashe County","Avery County","Beaufort County","Bertie County","Bladen County","Brunswick County","Buncombe County","Burke County","Cabarrus County","Caldwell County","Camden County","Carteret County","Caswell County","Catawba County","Chatham County","Cherokee County","Chowan County","Clay County","Cleveland County","Columbus County","Craven County","Cumberland County","Currituck County","Dare County","Davidson County","Davie County","Duplin County","Durham County","Edgecombe County","Forsyth County","Franklin County","Gaston County","Gates County","Graham County","Granville County","Greene County","Guilford County","Halifax County","Harnett County","Haywood County","Henderson County","Hertford County","Hoke County","Hyde County","Iredell County","Jackson County","Johnston County","Jones County","Lee County","Lenoir County","Lincoln County","McDowell County","Macon County","Madison County","Martin County","Mecklenburg County","Mitchell County","Montgomery County","Moore County","Nash County","New Hanover County","Northampton County","Onslow County","Orange County","Pamlico County","Pasquotank County","Pender County","Perquimans County","Person County","Pitt County","Polk County","Randolph County","Richmond County","Robeson County","Rockingham County","Rowan County","Rutherford County","Sampson County","Scotland County","Stanly County","Stokes County","Surry County","Swain County","Transylvania County","Tyrrell County","Union County","Vance County","Wake County","Warren County","Washington County","Watauga County","Wayne County","Wilkes County","Wilson County","Yadkin County","Yancey County"],
			"North Dakota":["Adams County","Barnes County","Benson County","Billings County","Bottineau County","Bowman County","Burke County","Burleigh County","Cass County","Cavalier County","Dickey County","Divide County","Dunn County","Eddy County","Emmons County","Foster County","Golden Valley County","Grand Forks County","Grant County","Griggs County","Hettinger County","Kidder County","LaMoure County","Logan County","McHenry County","McIntosh County","McKenzie County","McLean County","Mercer County","Morton County","Mountrail County","Nelson County","Oliver County","Pembina County","Pierce County","Ramsey County","Ransom County","Renville County","Richland County","Rolette County","Sargent County","Sheridan County","Sioux County","Slope County","Stark County","Steele County","Stutsman County","Towner County","Traill County","Walsh County","Ward County","Wells County","Williams County"],
			"Ohio":["Adams County","Allen County","Ashland County","Ashtabula County","Athens County","Auglaize County","Belmont County","Brown County","Butler County","Carroll County","Champaign County","Clark County","Clermont County","Clinton County","Columbiana County","Coshocton County","Crawford County","Cuyahoga County","Darke County","Defiance County","Delaware County","Erie County","Fairfield County","Fayette County","Franklin County","Fulton County","Gallia County","Geauga County","Greene County","Guernsey County","Hamilton County","Hancock County","Hardin County","Harrison County","Henry County","Highland County","Hocking County","Holmes County","Huron County","Jackson County","Jefferson County","Knox County","Lake County","Lawrence County","Licking County","Logan County","Lorain County","Lucas County","Madison County","Mahoning County","Marion County","Medina County","Meigs County","Mercer County","Miami County","Monroe County","Montgomery County","Morgan County","Morrow County","Muskingum County","Noble County","Ottawa County","Paulding County","Perry County","Pickaway County","Pike County","Portage County","Preble County","Putnam County","Richland County","Ross County","Sandusky County","Scioto County","Seneca County","Shelby County","Stark County","Summit County","Trumbull County","Tuscarawas County","Union County","Van Wert County","Vinton County","Warren County","Washington County","Wayne County","Williams County","Wood County","Wyandot County"],
			"Oklahoma":["Adair County","Alfalfa County","Atoka County","Beaver County","Beckham County","Blaine County","Bryan County","Caddo County","Canadian County","Carter County","Cherokee County","Choctaw County","Cimarron County","Cleveland County","Coal County","Comanche County","Cotton County","Craig County","Creek County","Custer County","Delaware County","Dewey County","Ellis County","Garfield County","Garvin County","Grady County","Grant County","Greer County","Harmon County","Harper County","Haskell County","Hughes County","Jackson County","Jefferson County","Johnston County","Kay County","Kingfisher County","Kiowa County","Latimer County","Le Flore County","Lincoln County","Logan County","Love County","McClain County","McCurtain County","McIntosh County","Major County","Marshall County","Mayes County","Murray County","Muskogee County","Noble County","Nowata County","Okfuskee County","Oklahoma County","Okmulgee County","Osage County","Ottawa County","Pawnee County","Payne County","Pittsburg County","Pontotoc County","Pottawatomie County","Pushmataha County","Roger Mills County","Rogers County","Seminole County","Sequoyah County","Stephens County","Texas County","Tillman County","Tulsa County","Wagoner County","Washington County","Washita County","Woods County","Woodward County"],
			"Oregon":["Baker County","Benton County","Clackamas County","Clatsop County","Columbia County","Coos County","Crook County","Curry County","Deschutes County","Douglas County","Gilliam County","Grant County","Harney County","Hood River County","Jackson County","Jefferson County","Josephine County","Klamath County","Lake County","Lane County","Lincoln County","Linn County","Malheur County","Marion County","Morrow County","Multnomah County","Polk County","Sherman County","Tillamook County","Umatilla County","Union County","Wallowa County","Wasco County","Washington County","Wheeler County","Yamhill County"],
			"Pennsylvania":["Adams County","Allegheny County","Armstrong County","Beaver County","Bedford County","Berks County","Blair County","Bradford County","Bucks County","Butler County","Cambria County","Cameron County","Carbon County","Centre County","Chester County","Clarion County","Clearfield County","Clinton County","Columbia County","Crawford County","Cumberland County","Dauphin County","Delaware County","Elk County","Erie County","Fayette County","Forest County","Franklin County","Fulton County","Greene County","Huntingdon County","Indiana County","Jefferson County","Juniata County","Lackawanna County","Lancaster County","Lawrence County","Lebanon County","Lehigh County","Luzerne County","Lycoming County","McKean County","Mercer County","Mifflin County","Monroe County","Montgomery County","Montour County","Northampton County","Northumberland County","Perry County","Philadelphia County","Pike County","Potter County","Schuylkill County","Snyder County","Somerset County","Sullivan County","Susquehanna County","Tioga County","Union County","Venango County","Warren County","Washington County","Wayne County","Westmoreland County","Wyoming County","York County"],
   			"Puerto Rico":["Adjuntas Municipality","Aguada Municipality","Aguadilla Pueblo Municipality","Aguas Buenas Municipality","Aibonito Municipality","Añasco Municipality","Arecibo Municipality","Arroyo Municipality", "Barceloneta Municipality","Barranquitas Municipality","Bayamón Municipality","Cabo Rojo Municipality","Caguas Municipality","Camuy Municipality","Canóvanas Municipality","Carolina Municipality","Cayey Municipality","Ceiba Municipality","Ciales Municipality","Cidra Municipality","Coamo Municipality","Comerío Municipality","Corozal Municipality","Culebra Municipality","Dorado Municipality","Fajardo Municipality","Florida Municipality","Guánica Municipality","Guayama Municipality","Guayanilla Municipality","Guaynabo Municipality","Gurabo Municipality","Hatillo Municipality","Hormigueros Municipality","Humacao Municipality","Isabela Municipality","Jayuya Municipality","Juana Díaz Municipality","Juncos Municipality","Lajas Municipality","Lares Municipality","Las Marías Municipality","Las Piedras Municipality","Loíza Municipality","Luquillo Municipality","Manatí Municipality","Maricao Municipality","Maunabo Municipality","Mayagüez Municipality","Moca Municipality","Morovis Municipality","Naguabo Municipality","Naranjito Municipality","Orocovis Municipality","Patillas Municipality","Peñuelas Municipality","Ponce Municipality","Quebradillas Municipality","Rincón Municipality","Río Grande Municipality","Sabana Grande Municipality","Salinas Municipality","San Germán Municipality","San Juan Municipality","San Lorenzo Municipality","San Sebastián Municipality","Santa Isabel Municipality","Toa Alta Municipality","Toa Baja Municipality","Trujillo Alto Municipality","Utuado Municipality","Vega Alta Municipality","Vega Baja Municipality","Vieques Municipality","Villalba Municipality","Yabucoa Municipality","Yauco Municipality"],
			"Rhode Island":["Bristol County","Kent County","Newport County","Providence County","Washington County"],
			"South Carolina":["Abbeville County","Aiken County","Allendale County","Anderson County","Bamberg County","Barnwell County","Beaufort County","Berkeley County","Calhoun County","Charleston County","Cherokee County","Chester County","Chesterfield County","Clarendon County","Colleton County","Darlington County","Dillon County","Dorchester County","Edgefield County","Fairfield County","Florence County","Georgetown County","Greenville County","Greenwood County","Hampton County","Horry County","Jasper County","Kershaw County","Lancaster County","Laurens County","Lee County","Lexington County","McCormick County","Marion County","Marlboro County","Newberry County","Oconee County","Orangeburg County","Pickens County","Richland County","Saluda County","Spartanburg County","Sumter County","Union County","Williamsburg County","York County"],
			"South Dakota":["Aurora County","Beadle County","Bennett County","Bon Homme County","Brookings County","Brown County","Brule County","Buffalo County","Butte County","Campbell County","Charles Mix County","Clark County","Clay County","Codington County","Corson County","Custer County","Davison County","Day County","Deuel County","Dewey County","Douglas County","Edmunds County","Fall River County","Faulk County","Grant County","Gregory County","Haakon County","Hamlin County","Hand County","Hanson County","Harding County","Hughes County","Hutchinson County","Hyde County","Jackson County","Jerauld County","Jones County","Kingsbury County","Lake County","Lawrence County","Lincoln County","Lyman County","McCook County","McPherson County","Marshall County","Meade County","Mellette County","Miner County","Minnehaha County","Moody County","Oglala Lakota County","Pennington County","Perkins County","Potter County","Roberts County","Sanborn County","Spink County","Stanley County","Sully County","Todd County","Tripp County","Turner County","Union County","Walworth County","Yankton County","Ziebach County"],
			"Tennessee":["Anderson County","Bedford County","Benton County","Bledsoe County","Blount County","Bradley County","Campbell County","Cannon County","Carroll County","Carter County","Cheatham County","Chester County","Claiborne County","Clay County","Cocke County","Coffee County","Crockett County","Cumberland County","Davidson County","Decatur County","DeKalb County","Dickson County","Dyer County","Fayette County","Fentress County","Franklin County","Gibson County","Giles County","Grainger County","Greene County","Grundy County","Hamblen County","Hamilton County","Hancock County","Hardeman County","Hardin County","Hawkins County","Haywood County","Henderson County","Henry County","Hickman County","Houston County","Humphreys County","Jackson County","Jefferson County","Johnson County","Knox County","Lake County","Lauderdale County","Lawrence County","Lewis County","Lincoln County","Loudon County","McMinn County","McNairy County","Macon County","Madison County","Marion County","Marshall County","Maury County","Meigs County","Monroe County","Montgomery County","Moore County","Morgan County","Obion County","Overton County","Perry County","Pickett County","Polk County","Putnam County","Rhea County","Roane County","Robertson County","Rutherford County","Scott County","Sequatchie County","Sevier County","Shelby County","Smith County","Stewart County","Sullivan County","Sumner County","Tipton County","Trousdale County","Unicoi County","Union County","Van Buren County","Warren County","Washington County","Wayne County","Weakley County","White County","Williamson County","Wilson County"],
			"Texas":["Anderson County","Andrews County","Angelina County","Aransas County","Archer County","Armstrong County","Atascosa County","Austin County","Bailey County","Bandera County","Bastrop County","Baylor County","Bee County","Bell County","Bexar County","Blanco County","Borden County","Bosque County","Bowie County","Brazoria County","Brazos County","Brewster County","Briscoe County","Brooks County","Brown County","Burleson County","Burnet County","Caldwell County","Calhoun County","Callahan County","Cameron County","Camp County","Carson County","Cass County","Castro County","Chambers County","Cherokee County","Childress County","Clay County","Cochran County","Coke County","Coleman County","Collin County","Collingsworth County","Colorado County","Comal County","Comanche County","Concho County","Cooke County","Coryell County","Cottle County","Crane County","Crockett County","Crosby County","Culberson County","Dallam County","Dallas County","Dawson County","Deaf Smith County","Delta County","Denton County","DeWitt County","Dickens County","Dimmit County","Donley County","Duval County","Eastland County","Ector County","Edwards County","Ellis County","El Paso County","Erath County","Falls County","Fannin County","Fayette County","Fisher County","Floyd County","Foard County","Fort Bend County","Franklin County","Freestone County","Frio County","Gaines County","Galveston County","Garza County","Gillespie County","Glasscock County","Goliad County","Gonzales County","Gray County","Grayson County","Gregg County","Grimes County","Guadalupe County","Hale County","Hall County","Hamilton County","Hansford County","Hardeman County","Hardin County","Harris County","Harrison County","Hartley County","Haskell County","Hays County","Hemphill County","Henderson County","Hidalgo County","Hill County","Hockley County","Hood County","Hopkins County","Houston County","Howard County","Hudspeth County","Hunt County","Hutchinson County","Irion County","Jack County","Jackson County","Jasper County","Jeff Davis County","Jefferson County","Jim Hogg County","Jim Wells County","Johnson County","Jones County","Karnes County","Kaufman County","Kendall County","Kenedy County","Kent County","Kerr County","Kimble County","King County","Kinney County","Kleberg County","Knox County","Lamar County","Lamb County","Lampasas County","La Salle County","Lavaca County","Lee County","Leon County","Liberty County","Limestone County","Lipscomb County","Live Oak County","Llano County","Loving County","Lubbock County","Lynn County","McCulloch County","McLennan County","McMullen County","Madison County","Marion County","Martin County","Mason County","Matagorda County","Maverick County","Medina County","Menard County","Midland County","Milam County","Mills County","Mitchell County","Montague County","Montgomery County","Moore County","Morris County","Motley County","Nacogdoches County","Navarro County","Newton County","Nolan County","Nueces County","Ochiltree County","Oldham County","Orange County","Palo Pinto County","Panola County","Parker County","Parmer County","Pecos County","Polk County","Potter County","Presidio County","Rains County","Randall County","Reagan County","Real County","Red River County","Reeves County","Refugio County","Roberts County","Robertson County","Rockwall County","Runnels County","Rusk County","Sabine County","San Augustine County","San Jacinto County","San Patricio County","San Saba County","Schleicher County","Scurry County","Shackelford County","Shelby County","Sherman County","Smith County","Somervell County","Starr County","Stephens County","Sterling County","Stonewall County","Sutton County","Swisher County","Tarrant County","Taylor County","Terrell County","Terry County","Throckmorton County","Titus County","Tom Green County","Travis County","Trinity County","Tyler County","Upshur County","Upton County","Uvalde County","Val Verde County","Van Zandt County","Victoria County","Walker County","Waller County","Ward County","Washington County","Webb County","Wharton County","Wheeler County","Wichita County","Wilbarger County","Willacy County","Williamson County","Wilson County","Winkler County","Wise County","Wood County","Yoakum County","Young County","Zapata County","Zavala County"],
			"Utah":["Beaver County","Box Elder County","Cache County","Carbon County","Daggett County","Davis County","Duchesne County","Emery County","Garfield County","Grand County","Iron County","Juab County","Kane County","Millard County","Morgan County","Piute County","Rich County","Salt Lake County","San Juan County","Sanpete County","Sevier County","Summit County","Tooele County","Uintah County","Utah County","Wasatch County","Washington County","Wayne County","Weber County"],
			"Vermont":["Addison County","Bennington County","Caledonia County","Chittenden County","Essex County","Franklin County","Grand Isle County","Lamoille County","Orange County","Orleans County","Rutland County","Washington County","Windham County","Windsor County"],
			"Virginia":["Accomack County","Albemarle County","Alleghany County","Amelia County","Amherst County","Appomattox County","Arlington County","Augusta County","Bath County","Bedford County","Bland County","Botetourt County","Brunswick County","Buchanan County","Buckingham County","Campbell County","Caroline County","Carroll County","Charles City County","Charlotte County","Chesterfield County","Clarke County","Craig County","Culpeper County","Cumberland County","Dickenson County","Dinwiddie County","Essex County","Fairfax County","Fauquier County","Floyd County","Fluvanna County","Franklin County","Frederick County","Giles County","Gloucester County","Goochland County","Grayson County","Greene County","Greensville County","Halifax County","Hanover County","Henrico County","Henry County","Highland County","Isle of Wight County","James City County","King and Queen County","King George County","King William County","Lancaster County","Lee County","Loudoun County","Louisa County","Lunenburg County","Madison County","Mathews County","Mecklenburg County","Middlesex County","Montgomery County","Nelson County","New Kent County","Northampton County","Northumberland County","Nottoway County","Orange County","Page County","Patrick County","Pittsylvania County","Powhatan County","Prince Edward County","Prince George County","Prince William County","Pulaski County","Rappahannock County","Richmond County","Roanoke County","Rockbridge County","Rockingham County","Russell County","Scott County","Shenandoah County","Smyth County","Southampton County","Spotsylvania County","Stafford County","Surry County","Sussex County","Tazewell County","Warren County","Washington County","Westmoreland County","Wise County","Wythe County","York County","Alexandria County","Bristol County","Buena Vista County","Charlottesville County","Chesapeake County","Colonial Heights County","Covington County","Danville County","Emporia County","Fairfax County","Falls Church County","Franklin County","Fredericksburg County","Galax County","Hampton County","Harrisonburg County","Hopewell County","Lexington County","Lynchburg County","Manassas County","Manassas Park County","Martinsville County","Newport News County","Norfolk County","Norton County","Petersburg County","Poquoson County","Portsmouth County","Radford County","Richmond County","Roanoke County","Salem County","Staunton County","Suffolk County","Virginia Beach County","Waynesboro County","Williamsburg County","Winchester County"],
			"Washington":["Adams County","Asotin County","Benton County","Chelan County","Clallam County","Clark County","Columbia County","Cowlitz County","Douglas County","Ferry County","Franklin County","Garfield County","Grant County","Grays Harbor County","Island County","Jefferson County","King County","Kitsap County","Kittitas County","Klickitat County","Lewis County","Lincoln County","Mason County","Okanogan County","Pacific County","Pend Oreille County","Pierce County","San Juan County","Skagit County","Skamania County","Snohomish County","Spokane County","Stevens County","Thurston County","Wahkiakum County","Walla Walla County","Whatcom County","Whitman County","Yakima County"],
			"West Virginia":["Barbour County","Berkeley County","Boone County","Braxton County","Brooke County","Cabell County","Calhoun County","Clay County","Doddridge County","Fayette County","Gilmer County","Grant County","Greenbrier County","Hampshire County","Hancock County","Hardy County","Harrison County","Jackson County","Jefferson County","Kanawha County","Lewis County","Lincoln County","Logan County","McDowell County","Marion County","Marshall County","Mason County","Mercer County","Mineral County","Mingo County","Monongalia County","Monroe County","Morgan County","Nicholas County","Ohio County","Pendleton County","Pleasants County","Pocahontas County","Preston County","Putnam County","Raleigh County","Randolph County","Ritchie County","Roane County","Summers County","Taylor County","Tucker County","Tyler County","Upshur County","Wayne County","Webster County","Wetzel County","Wirt County","Wood County","Wyoming County"],
			"Wisconsin":["Adams County","Ashland County","Barron County","Bayfield County","Brown County","Buffalo County","Burnett County","Calumet County","Chippewa County","Clark County","Columbia County","Crawford County","Dane County","Dodge County","Door County","Douglas County","Dunn County","Eau Claire County","Florence County","Fond du Lac County","Forest County","Grant County","Green County","Green Lake County","Iowa County","Iron County","Jackson County","Jefferson County","Juneau County","Kenosha County","Kewaunee County","La Crosse County","Lafayette County","Langlade County","Lincoln County","Manitowoc County","Marathon County","Marinette County","Marquette County","Menominee County","Milwaukee County","Monroe County","Oconto County","Oneida County","Outagamie County","Ozaukee County","Pepin County","Pierce County","Polk County","Portage County","Price County","Racine County","Richland County","Rock County","Rusk County","St. Croix County","Sauk County","Sawyer County","Shawano County","Sheboygan County","Taylor County","Trempealeau County","Vernon County","Vilas County","Walworth County","Washburn County","Washington County","Waukesha County","Waupaca County","Waushara County","Winnebago County","Wood County"],
			"Wyoming":["Albany County","Big Horn County","Campbell County","Carbon County","Converse County","Crook County","Fremont County","Goshen County","Hot Springs County","Johnson County","Laramie County","Lincoln County","Natrona County","Niobrara County","Park County","Platte County","Sheridan County","Sublette County","Sweetwater County","Teton County","Uinta County","Washakie County","Weston County"]
			}};
		if(state === ""){
			//no state return the null option
			var html = "<option style='color: red;' value=''>" + selectTitle + "</option>";
		}
		else{
			var counties = countiesJson.states[state];
			var html = "<option style='color: red;' value=''>" + selectTitle + "</option>";
			$.each(counties, function(index, value){
				html += "<option value='" + value + "' data-display='" + value + "'>" + value + "</option>";
			});
		}

		var json = { 
			htmlText: [
				html
			]
		};

		return json;
	}
	

	function hueRotate(rgb,angle) {
		if(angle == undefined) angle = 0;
		angle = angle / 180 * Math.PI;
		var sin = Math.sin(angle);
		var cos = Math.cos(angle);
	
		rgb = createMultiply(rgb, [
		0.213 + cos * 0.787 - sin * 0.213,
		0.715 - cos * 0.715 - sin * 0.715,
		0.072 - cos * 0.072 + sin * 0.928,
		0.213 - cos * 0.213 + sin * 0.143,
		0.715 + cos * 0.285 + sin * 0.140,
		0.072 - cos * 0.072 - sin * 0.283,
		0.213 - cos * 0.213 - sin * 0.787,
		0.715 - cos * 0.715 + sin * 0.715,
		0.072 + cos * 0.928 + sin * 0.072,
		]);
		return rgb;
	}
	
	function grayscale(rgb,value) {
		if(value == undefined) value = 1;
		rgb = createMultiply(rgb, [
		0.2126 + 0.7874 * (1 - value),
		0.7152 - 0.7152 * (1 - value),
		0.0722 - 0.0722 * (1 - value),
		0.2126 - 0.2126 * (1 - value),
		0.7152 + 0.2848 * (1 - value),
		0.0722 - 0.0722 * (1 - value),
		0.2126 - 0.2126 * (1 - value),
		0.7152 - 0.7152 * (1 - value),
		0.0722 + 0.9278 * (1 - value),
		]);
		return rgb;
	}
	
	function sepia(rgb,value) {
		if(value == undefined) value = 1;
		rgb = createMultiply(rgb, [
		0.393 + 0.607 * (1 - value),
		0.769 - 0.769 * (1 - value),
		0.189 - 0.189 * (1 - value),
		0.349 - 0.349 * (1 - value),
		0.686 + 0.314 * (1 - value),
		0.168 - 0.168 * (1 - value),
		0.272 - 0.272 * (1 - value),
		0.534 - 0.534 * (1 - value),
		0.131 + 0.869 * (1 - value),
		]);
		return rgb;
	}
	
	function saturate(rgb,value) {
		if(value == undefined) value = 1;
		rgb = createMultiply(rgb, [
		0.213 + 0.787 * value,
		0.715 - 0.715 * value,
		0.072 - 0.072 * value,
		0.213 - 0.213 * value,
		0.715 + 0.285 * value,
		0.072 - 0.072 * value,
		0.213 - 0.213 * value,
		0.715 - 0.715 * value,
		0.072 + 0.928 * value,
		]);
		return rgb;
	}
	
	function createMultiply(rgb,matrix) {
		var newR = clampColor(rgb.r * matrix[0] + rgb.g * matrix[1] + rgb.b * matrix[2]);
		var newG = clampColor(rgb.r * matrix[3] + rgb.g * matrix[4] + rgb.b * matrix[5]);
		var newB = clampColor(rgb.r * matrix[6] + rgb.g * matrix[7] + rgb.b * matrix[8]);
		return {r: newR, g: newG, b: newB};
	}
	
	function brightness(rgb, value) {
		if(value == undefined) value = 1;
		rgb = createLinear(rgb,value);
		return rgb;
	}
	function contrast(rgb,value) {
		if(value == undefined) value = 1;
		rgb = createLinear(rgb,value, -(0.5 * value) + 0.5);
		return rgb;
	}
	
	function createLinear(rgb,slope, intercept) {
		if(slope == undefined) slope = 1;
		if(intercept == undefined) intercept = 0;
		var newR = clampColor(rgb.r * slope + intercept * 255);
		var newG = clampColor(rgb.g * slope + intercept * 255);
		var newB = clampColor(rgb.b * slope + intercept * 255);
		return {r: newR, g: newG, b: newB};
	}
	
	function invert(rgb, value) {
		if(value == undefined) value = 1;
		var newR = clampColor((value + (rgb.r / 255) * (1 - 2 * value)) * 255);
		var newG = clampColor((value + (rgb.g / 255) * (1 - 2 * value)) * 255);
		var newB = clampColor((value + (rgb.b / 255) * (1 - 2 * value)) * 255);
		return {r: newR, g: newG, b: newB};
	}
	
	function hsl(rgb) {
		var r = rgb.r / 255;
		var g = rgb.g / 255;
		var b = rgb.b / 255;
		var max = Math.max(r, g, b);
		var min = Math.min(r, g, b);
		var h = s = l = (max + min) / 2;
	
		if (max == min) {
			h = s = 0;
		} else {
			var d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
			if(max === r) h = (g - b) / d + (g < b ? 6 : 0);
			if(max === g) h = (b - r) / d + 2;
			if(max === b) h = (r - g) / d + 4;
			h = h/6;
		}
	
		return {
			h: h * 100,
			s: s * 100,
			l: l * 100,
		};
	}
	
	function clampColor(value) {
		if (value > 255) {
		value = 255;
		} else if (value < 0) {
		value = 0;
		}
		return value;
	}
	
	
	function findFilter(rgb) {
		var result = solveNarrow(rgb,solveWide(rgb));
		return {
			filter: getFinalFilter(result.values),
		};
	}
	
	function solveWide(rgb) {
		var A = 5;
		var c = 15;
		var a = [60, 180, 18000, 600, 1.2, 1.2];
	
		var best = { loss: Infinity };
		for (var i = 0; best.loss > 25 && i < 3; i++) {
			var initial = [50, 20, 3750, 50, 100, 100];
			var result = findBest(rgb, A, a, c, initial, 1000);
			if (result.loss < best.loss) {
				best = result;
			}
		}
		return best;
	}
	
	function solveNarrow(rgb,wide) {
		var A = wide.loss;
		var c = 2;
		var A1 = A + 1;
		var a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
		return findBest(rgb,A, a, c, wide.values, 500);
	}
	
	function findBest(rgb, A, a, c, values, iters) {
		var alpha = 1;
		var gamma = 0.16666666666666666;
		var best = null;
		var bestLoss = Infinity;
		var deltas = new Array(6);
		var highArgs = new Array(6);
		var lowArgs = new Array(6);
	
		for (var k = 0; k < iters; k++) {
			var ck = c / Math.pow(k + 1, gamma);
			for (var i = 0; i < 6; i++) {
				deltas[i] = Math.random() > 0.5 ? 1 : -1;
				highArgs[i] = values[i] + ck * deltas[i];
				lowArgs[i] = values[i] - ck * deltas[i];
			}
			var lossDiff = findLoss(rgb,highArgs) - findLoss(rgb,lowArgs);
			for (var i = 0; i < 6; i++) {
				var g = lossDiff / (2 * ck) * deltas[i];
				var ak = a[i] / Math.pow(A + k + 1, alpha);
				values[i] = fix(values[i] - ak * g, i);
			}
		
			var loss = findLoss(rgb,values);
			if (loss < bestLoss) {
				best = values.slice(0);
				bestLoss = loss;
			}
		}
		return { values: best, loss: bestLoss };
	}

	function fix(value, idx) {
		var max = 100;
		if (idx === 2) {
			max = 7500;
		} else if (idx === 4 || idx === 5) {
			max = 200;
		}
	
		if (idx === 3 ) {
			if (value > max) {
				value = value % max;
			} else if (value < 0) {
				value = max + value % max;
			}
		} else if (value < 0) {
			value = 0;
		} else if (value > max) {
			value = max;
		}
		return value;
	}

	function findLoss(rgb,filters) {
		var blackRGB = {r: 0, g: 0, b: 0};
		blackRGB = invert(blackRGB, (filters[0] / 100));
		//console.log(blackRGB);
		blackRGB = sepia(blackRGB, (filters[1] / 100));
		//console.log(blackRGB);
		blackRGB = saturate(blackRGB, (filters[2] / 100));
		//console.log(blackRGB);
		blackRGB = hueRotate(blackRGB, (filters[3] * 3.6));
		//console.log(blackRGB);
		blackRGB = brightness(blackRGB, (filters[4] / 100));
		//console.log(blackRGB);
		blackRGB = contrast(blackRGB, (filters[5] / 100));
		//console.log(blackRGB);
		var colorHSL = hsl(blackRGB);
		var rgbHSL = hsl(rgb);
		return (Math.abs(blackRGB.r - rgb.r) + Math.abs(blackRGB.g - rgb.g) + Math.abs(blackRGB.b - rgb.b) + Math.abs(colorHSL.h - rgbHSL.h) + Math.abs(colorHSL.s - rgbHSL.s) + Math.abs(colorHSL.l - rgbHSL.l));
	}
	
	function getFinalFilter(filters) {
		function fmt(idx, multiplier) {
			if(multiplier == undefined) multiplier = 1;
			return Math.round(filters[idx] * multiplier);
		}
		return 'invert('+ fmt(0) + '%) sepia('+ fmt(1) + '%) saturate('+ fmt(2) + '%) hue-rotate('+ fmt(3, 3.6) + 'deg) brightness('+ fmt(4) + '%) contrast('+ fmt(5) + '%)';
	}
  
});
